import React, {Component} from 'react';
import {action, observable} from 'mobx';
import {inject, observer} from 'mobx-react';
import _ from "underscore";
import {
  Row,
  Col,
  Modal,
  ModalBody,
  FormInput,
  Button,
  FormCheckbox,
} from "shards-react";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './style.scss'

import PageTitle from "../../../components/common/PageTitle";
import HelpButton from "../../../components/common/HelpButton";
import guideManager from "../../../guides/guideManager";
import FeatherIcon from 'feather-icons-react';
import moment from "moment";
import ModalLoading from "../../../components/common/ModalLoading";

function isOverPeriod(date1, date2, periodArr) {
  const startDate = moment(date1);
  const endDate = moment(date2);
  const periodDiff = endDate.diff(startDate, periodArr[1]);
  return periodDiff <= periodArr[0];
}

@inject(({ common }) => ({ getStoreTotalConfig: common.getStoreTotalConfig, updateDoc: common.updateDoc, getDoc: common.getDoc }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me, getMe:teamUser.getMe }))
@inject(({ company }) => ({ updateStore:company.updateStore, getApplySkins:company.getApplySkins, getApplyShop:company.getApplyShop, applyAllSkin:company.applyAllSkin, applySkin:company.applySkin}))
@inject(({ product }) => ({ getProductList: product.getProductList, setProductSync: product.setProductSync }))
@inject(({ review }) => ({ setReviewSync: review.setReviewSync, getStatusReviewBoard: review.getStatusReviewBoard, getReviewList: review.getReviewList }))

@observer
class EasySetting extends Component {

  //basic
  @observable teamUser = {};
  @observable permissions = {}
  @observable store = {};
  @observable isLogin = false;
  @observable isLoading = false;

  //page
  @observable skins = [];
  @observable shops = [];
  @observable selShop = {};
  @observable syncReviewValue = {
    startDate: moment().add(-1, 'days').format('yyyy-MM-DD'),
    endDate: moment().format('yyyy-MM-DD'),
    isOverwrite: false,
  };

  // Installation progress tracking
  @observable productCount = 0;
  @observable reviewCount = 0;
  @observable activeSkinCount = 0;

  // 전체 리뷰 한번에 가져오기
  @observable bulkSyncRunning = false;
  @observable bulkSyncCancelRequested = false;
  @observable bulkSyncProgress = {
    rangeIndex: 0,         // 처리한 범위 수
    totalFetched: 0,       // 누적 가져온 리뷰 수
    zeroStreak: 0,         // 연속 0건 카운터
    currentStart: '',      // 현재 처리 중 범위 시작
    currentEnd: '',        // 현재 처리 중 범위 종료
    lastInsert: 0          // 직전 호출 insertReviewCount
  };

  @observable reviewWrightLimit = {
    store_id: null,
    isUseNormalReview: true,
    isUseNoPurchase: false,
  }

  @observable basicSettings = {
    writer: '',
    password: '',
    store_id: null,
    minChars: 10,
    maxChars: 5000,
    mainPhase: [],
    subPhase: [],
    writeEnabledState: 1,
    writeEnabledDate: 50,
    isDeliveryRating: false,
    defaultColor: "#000000",
    themeColor: "#121212",
    ratingMarkColor: "#121212",
    subColor: "#6255F6",
    isNoDisProductReview: false,
    writerDisType: 1,
    perListCount: 5,
    listSortType: 'newst',
    widgetCssUrl: ''
  };

  @observable serarchPeriod = [3, "months", "3개월 단위"];
  @observable newMainPhase = '';
  @observable newSubPhase = '';

  @observable reviewFiltering = {
    store_id: null,
    isRecmFilter: false,
    filterWords: []
  };
  @observable filterWords = [];
  @observable newFilterWord = { block: '', alter: ''};

  //modals
  @observable isWidgetMode = false;
  @observable isShowCalendarForRS = {
    startDate: false,
    endDate: false
  }
  @observable modals = {
    cafeSettingData: {},
    isCafeSettingModal: false
  };

  // AI 자동 설치
  @observable aiAuto = {
    running: false,
    currentStep: 0,    // 0: 대기, 1: 상품, 2: 리뷰, 3: 스킨, 4: 완료
    log: [],           // {time, step, msg, type}
    cancel: false,
    completedSteps: [],     // [1, 2, 3] — AI가 실제로 실행 완료한 단계 (데이터 카운트와 별개)
    startedAt: null,
    completedAt: null,
    summary: null     // {durationSec, step1, step2, step3, errors}
  };

  // 사전 설정 iframe 모달
  @observable configIframe = {
    open: false,
    path: '',
    title: ''
  };

  @action openConfigIframe = (path, title) => {
    this.configIframe.path = path;
    this.configIframe.title = title;
    this.configIframe.open = true;
  };

  @action closeConfigIframe = () => {
    this.configIframe.open = false;
    this.configIframe.path = '';
    this.configIframe.title = '';
  };

  constructor(props) {
    super(props);
    this.init()
  }

  componentDidMount() {
    this._configIframeKeyHandler = (e) => {
      if (e.key === 'Escape' && this.configIframe.open) this.closeConfigIframe();
    };
    window.addEventListener('keydown', this._configIframeKeyHandler);
    // 첫 방문 시 페이지 가이드 자동 1회 — 사전 설정을 먼저 하도록 안내
    setTimeout(() => guideManager.maybeAutoStart('easySetting', { storeId: this.store && this.store._id }), 600);
  }

  componentWillUnmount() {
    if (this._configIframeKeyHandler) window.removeEventListener('keydown', this._configIframeKeyHandler);
  }


  @action
  init = async (key) => {
    let _this = this;
    if(this.props.isLogin) {
      //basic
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.teamUser.store;

      // 무료 사용자도 페이지 진입은 허용 — 설정 변경만 paywall 배너로 안내한다
      console.log(this.store);
      this.permissions = this.props.me.permissions;
      this.props.getStoreTotalConfig({store_id: this.teamUser.selStore_id, shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1}, function(res) {
        if(res.errors && res.errors.length > 0) {
          alert(res.errors[0].message);
        }
        else {
          let results;
          if(res) {
            results = res;
            if(results.basicSettings) {
              let getSettings = _.pick(results.basicSettings, 'writer', 'password', 'replyTyep', 'store_id', 'minChars', 'maxChars',
                  'mainPhase', 'subPhase', 'writeEnabledState', 'writeEnabledDate', 'isDeliveryRating', 'productReviewInfoType', 'reviewDetailV',
                  'defaultColor', 'themeColor', 'ratingMarkColor', 'subColor', 'isNoDisReviewDate', 'isNoDisReviewWriter', 'writerDisTextCount', 'isNoDisProductReview', 'writerDisType', 'perListCount', 'listSortType', 'widgetCssUrl');
              _this.basicSettings = {..._this.basicSettings , ...getSettings};
            }
            if(results.filtering) {
              _this.reviewFiltering = results.filtering;
              _this.filterWords = results.filtering.filterWords;
            }
            if(results.writeLimit) {
              _this.reviewWrightLimit = results.writeLimit;
            }
            _this.basicSettings.store_id = _this.teamUser.selStore_id;
            _this.basicSettings.shopNo = _this.teamUser.selShopNo ? _this.teamUser.selShopNo : 1;
            _this.reviewFiltering.store_id = _this.teamUser.selStore_id;
            _this.reviewFiltering.shopNo = _this.teamUser.selShopNo ? _this.teamUser.selShopNo : 1;
            _this.reviewWrightLimit.store_id = _this.teamUser.selStore_id;
            _this.reviewWrightLimit.shopNo = _this.teamUser.selShopNo ? _this.teamUser.selShopNo : 1;
          }
        }
      });
      // let me = await this.props.getMe();


      this.getApplySkins(false);
      this.getApplyShop(false);
      this.getInstallationProgress();

    }
  };

  @action
  getInstallationProgress = async () => {
    let _this = this;

    // Get product count
    this.props.getProductList({
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      limit: 1,
      page: 1
    }, function(res) {
      if(res && res.totalDocs) {
        _this.productCount = res.totalDocs;
      }
    });

    // Get review count
    this.props.getReviewList({
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      limit: 1,
      page: 1
    }, function(res) {
      if(res && res.totalDocs) {
        _this.reviewCount = res.totalDocs;
      }
    });
  };

  checkPaidUser = async (store) => {
    if(!store.isPaidUser) {
      toast.error('유료 플랜 전용 기능입니다. 결제 페이지에서 플랜을 활성화해주세요.');
    }
    return store.isPaidUser;
  }

  onChangeChecked = async (event, targetObj, keyArray) => {
    if(keyArray[0]) {
      targetObj[keyArray[0]] = !targetObj[keyArray[0]];
      if(keyArray[0] === 'isSetScript') {
        targetObj.id = targetObj._id;
        this.props.applySkin(targetObj, function(res) {
          if(res.errors && res.errors.length > 0) {
            alert(res.errors[0].message);
            targetObj[keyArray[0]] = !targetObj[keyArray[0]];
          }
          else {
            toast('처리 되었습니다.');
            //targetObj[keyArray[0]] = !targetObj[keyArray[0]];
          }
        });
      }
    }
  };

  @action
  getApplySkins = async (actSync) => {
    let _this = this;
    let updateStore = {
      store_id: this.teamUser.store._id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      actSync: actSync
    }
    this.props.getApplySkins( updateStore, function(res) {
      if(res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      }
      else {
        _this.skins = res.data;
        // Count active skins
        _this.activeSkinCount = res.data.filter(skin => skin.isSetScript).length;
        if(actSync) {
          toast('업데이트가 완료 되었습니다.');
        }
      }
    });
  }

  @action
  getApplyShop = async (actSync) => {
    let _this = this;
    let updateStore = {
      store_id: this.teamUser.store._id
    }
    this.props.getApplyShop( updateStore, function(res) {
      if(res.errors && res.errors.length > 0) {
        //toast(res.errors[0].message);
      }
      else {
        _this.shops = _.indexBy(res.data, 'platformShopNo');
        _this.selShop = _this.shops[_this.teamUser.selShopNo];

      }
    });
  }

  onChangeCheckedforApplySkin = async (event, targetObj, keyArray) => {
    let _this = this;
    _this.isLoading = true;
    if(keyArray[0]) {
      targetObj[keyArray[0]] = !targetObj[keyArray[0]];
      if(this.teamUser.isPaidShop || !targetObj[keyArray[0]]) {
        if(keyArray[0] === 'isSetScript') {
          targetObj.id = targetObj._id;
          targetObj.shopNo = _this.teamUser.selShopNo ? _this.teamUser.selShopNo: 1;
          this.props.applySkin(targetObj, function(res) {
            if(res.errors && res.errors.length > 0) {
              alert(res.errors[0].message);
              targetObj[keyArray[0]] = !targetObj[keyArray[0]];
              _this.isLoading = false;
            }
            else {
              _this.isLoading = false;
              toast('처리 되었습니다.');
              // Update active skin count
              _this.activeSkinCount = _this.skins.filter(skin => skin.isSetScript).length;
              //targetObj[keyArray[0]] = !targetObj[keyArray[0]];
            }

          });
        }
        else {
          _this.isLoading = false;
        }
      }
      else {
        _this.isLoading = false;
        targetObj[keyArray[0]] = false;
        let cf = window.confirm('주문 완료 후 이용 가능합니다. 주문 페이지로 이동하시겠습니까?');
        if(cf) {
          window.location.href = '/inAppOrder';
        }
      }
    }


  };

  // === AI 자동 설치 — 1, 2, 3 단계를 순차 실행 ===
  @action aiLog = (step, msg, type) => {
    this.aiAuto.log.push({ time: moment().format('HH:mm:ss'), step, msg, type: type || 'info' });
  };

  // setProductSync 의 Promise 변형
  setProductSyncAsync = () => {
    let _this = this;
    return new Promise((resolve) => {
      const data = {
        store_id: _this.store._id,
        shopNo: _this.teamUser.selShopNo,
        teamUser_id: _this.teamUser.id,
      };
      _this.props.setProductSync(data, function(res) {
        if (res && res.errors && res.errors.length > 0) {
          resolve({ ok: false, message: res.errors[0].message });
          return;
        }
        const cnt = (res && res.data && res.data.productCount) || 0;
        _this.productCount = cnt;
        // 캐시 정리
        try {
          for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.indexOf('goodList_' + _this.store.platformId) > -1) {
              localStorage.removeItem(key);
            }
          }
        } catch (e) {}
        resolve({ ok: true, count: cnt });
      });
    });
  };

  // 단일 스킨 활성화 Promise
  applySkinAsync = (skin) => {
    let _this = this;
    return new Promise((resolve) => {
      const target = Object.assign({}, skin, {
        id: skin._id,
        shopNo: _this.teamUser.selShopNo || 1,
        isSetScript: true
      });
      _this.props.applySkin(target, function(res) {
        if (res && res.errors && res.errors.length > 0) {
          resolve({ ok: false, message: res.errors[0].message });
          return;
        }
        // 로컬 상태 업데이트
        if (_this.skins) {
          const found = _this.skins.find(s => s._id === skin._id);
          if (found) found.isSetScript = true;
          _this.activeSkinCount = _this.skins.filter(s => s.isSetScript).length;
        }
        resolve({ ok: true });
      });
    });
  };

  // getApplySkins 의 Promise 변형
  getApplySkinsAsync = (actSync) => {
    let _this = this;
    return new Promise((resolve) => {
      const data = {
        store_id: _this.teamUser.store._id,
        shopNo: _this.teamUser.selShopNo ? _this.teamUser.selShopNo : 1,
        actSync: actSync
      };
      _this.props.getApplySkins(data, function(res) {
        if (res && res.errors && res.errors.length > 0) {
          resolve({ ok: false, message: res.errors[0].message });
          return;
        }
        _this.skins = res.data;
        _this.activeSkinCount = (res.data || []).filter(s => s.isSetScript).length;
        resolve({ ok: true, skins: res.data || [] });
      });
    });
  };

  // selShop(현재 매장 정보) 갱신
  refreshSelShopAsync = () => {
    let _this = this;
    return new Promise((resolve) => {
      _this.props.getApplyShop({ store_id: _this.teamUser.store._id }, function(res) {
        if (res && res.data) {
          _this.shops = _.indexBy(res.data, 'platformShopNo');
          _this.selShop = _this.shops[_this.teamUser.selShopNo];
        }
        resolve();
      });
    });
  };

  @action
  runAiAutoSetup = async () => {
    if (this.aiAuto.running) return;
    if (!await this.checkPaidUser(this.store)) return;

    const aiDoneSet = (this.aiAuto.completedSteps || []);
    const s1 = this.productCount > 0 || aiDoneSet.indexOf(1) !== -1;
    const s2 = this.reviewCount > 0 || aiDoneSet.indexOf(2) !== -1;
    const s3 = this.activeSkinCount > 0 || aiDoneSet.indexOf(3) !== -1;
    const remaining = (s1 ? 0 : 1) + (s2 ? 0 : 1) + (s3 ? 0 : 1);
    if (remaining === 0) {
      toast.success('모든 단계가 이미 완료되어 있습니다.');
      return;
    }
    if (!window.confirm(
      `AI 자동 처리로 남은 ${remaining}개 단계를 순차 실행합니다.\n\n` +
      `① 상품 가져오기\n` +
      `② 전체 리뷰 가져오기 (시간이 다소 걸릴 수 있음)\n` +
      `③ 스킨 새로고침 후 PC/모바일 사용 중 스킨 활성화\n\n` +
      `진행 중에는 페이지를 닫지 마세요. 계속할까요?`
    )) return;

    this.aiAuto.running = true;
    this.aiAuto.cancel = false;
    this.aiAuto.log = [];
    this.aiAuto.currentStep = 0;
    this.aiAuto.completedSteps = [];
    this.aiAuto.startedAt = Date.now();
    this.aiAuto.completedAt = null;
    this.aiAuto.summary = null;

    const summary = {
      step1: { ran: false, skipped: false, count: 0, error: null },
      step2: { ran: false, skipped: false, count: 0, ranges: 0, error: null },
      step3: { ran: false, pc: null, mobile: null, errors: [] }
    };

    try {
      // ===== Step 1: 상품 가져오기 =====
      this.aiAuto.currentStep = 1;
      if (this.productCount > 0) {
        this.aiLog(1, '상품이 이미 동기화되어 있습니다 — 건너뜀', 'skip');
        summary.step1.skipped = true;
        summary.step1.count = this.productCount;
      } else {
        this.aiLog(1, '상품 가져오기 시작…');
        const r1 = await this.setProductSyncAsync();
        if (!r1.ok) {
          summary.step1.error = r1.message || '알 수 없는 오류';
          this.aiLog(1, '실패: ' + summary.step1.error, 'error');
          throw new Error(summary.step1.error);
        }
        summary.step1.ran = true;
        summary.step1.count = r1.count;
        this.aiLog(1, `완료 — ${r1.count}개 상품 동기화됨`, 'success');
      }
      this.aiAuto.completedSteps.push(1);
      if (this.aiAuto.cancel) throw new Error('사용자에 의해 중지됨');

      // ===== Step 2: 전체 리뷰 가져오기 =====
      this.aiAuto.currentStep = 2;
      if (this.reviewCount > 0) {
        this.aiLog(2, '리뷰가 이미 동기화되어 있습니다 — 건너뜀', 'skip');
        summary.step2.skipped = true;
        summary.step2.count = this.reviewCount;
      } else {
        this.aiLog(2, `전체 리뷰 가져오기 시작 (${this.serarchPeriod[0]}${this.serarchPeriod[1] === 'months' ? '개월' : this.serarchPeriod[1]} 단위)…`);
        await this.runAllReviewsForAi();
        summary.step2.ran = true;
        summary.step2.count = this.bulkSyncProgress.totalFetched;
        summary.step2.ranges = this.bulkSyncProgress.rangeIndex;
        this.aiLog(2, `완료 — 누적 ${summary.step2.count.toLocaleString()}건 (${summary.step2.ranges}개 구간)`, 'success');
      }
      this.aiAuto.completedSteps.push(2);
      if (this.aiAuto.cancel) throw new Error('사용자에 의해 중지됨');

      // ===== Step 3: 스킨 활성화 =====
      this.aiAuto.currentStep = 3;
      this.aiLog(3, '스킨 목록 새로고침…');
      const skinRes = await this.getApplySkinsAsync(true);
      if (!skinRes.ok) {
        summary.step3.errors.push('스킨 목록 조회 실패: ' + (skinRes.message || ''));
        this.aiLog(3, '스킨 목록 조회 실패: ' + (skinRes.message || ''), 'error');
        throw new Error(skinRes.message || '스킨 목록 조회 실패');
      }
      await this.refreshSelShopAsync();
      const skins = this.skins || [];
      const sel = this.selShop || {};
      const pcSkin = skins.find(s => s.skin_no === sel.pcSkinNo);
      const mobileSkin = skins.find(s => s.skin_no === sel.mobileSkinNo);

      // PC 스킨
      if (pcSkin) {
        if (pcSkin.isSetScript) {
          this.aiLog(3, `PC 사용 중 스킨(${pcSkin.skin_name || pcSkin.skin_no})은 이미 활성화됨 — 건너뜀`, 'skip');
          summary.step3.pc = { name: pcSkin.skin_name || ('스킨 ' + pcSkin.skin_no), skipped: true };
        } else {
          this.aiLog(3, `PC 사용 중 스킨 활성화 중: ${pcSkin.skin_name || pcSkin.skin_no}`);
          const r = await this.applySkinAsync(pcSkin);
          if (r.ok) {
            this.aiLog(3, 'PC 스킨 활성화 완료', 'success');
            summary.step3.pc = { name: pcSkin.skin_name || ('스킨 ' + pcSkin.skin_no), activated: true };
          } else {
            this.aiLog(3, `PC 스킨 활성화 실패: ${r.message || ''}`, 'error');
            summary.step3.errors.push('PC 스킨 활성화 실패: ' + (r.message || ''));
            summary.step3.pc = { name: pcSkin.skin_name || ('스킨 ' + pcSkin.skin_no), error: r.message };
          }
        }
      } else {
        this.aiLog(3, 'PC 사용 중 스킨을 찾을 수 없습니다 (selShop.pcSkinNo 미설정)', 'warn');
        summary.step3.errors.push('PC 사용 중 스킨 미설정');
      }

      // 모바일 스킨
      if (mobileSkin) {
        if (mobileSkin.isSetScript) {
          this.aiLog(3, `모바일 사용 중 스킨(${mobileSkin.skin_name || mobileSkin.skin_no})은 이미 활성화됨 — 건너뜀`, 'skip');
          summary.step3.mobile = { name: mobileSkin.skin_name || ('스킨 ' + mobileSkin.skin_no), skipped: true };
        } else {
          this.aiLog(3, `모바일 사용 중 스킨 활성화 중: ${mobileSkin.skin_name || mobileSkin.skin_no}`);
          const r = await this.applySkinAsync(mobileSkin);
          if (r.ok) {
            this.aiLog(3, '모바일 스킨 활성화 완료', 'success');
            summary.step3.mobile = { name: mobileSkin.skin_name || ('스킨 ' + mobileSkin.skin_no), activated: true };
          } else {
            this.aiLog(3, `모바일 스킨 활성화 실패: ${r.message || ''}`, 'error');
            summary.step3.errors.push('모바일 스킨 활성화 실패: ' + (r.message || ''));
            summary.step3.mobile = { name: mobileSkin.skin_name || ('스킨 ' + mobileSkin.skin_no), error: r.message };
          }
        }
      } else {
        this.aiLog(3, '모바일 사용 중 스킨을 찾을 수 없습니다 (selShop.mobileSkinNo 미설정)', 'warn');
        summary.step3.errors.push('모바일 사용 중 스킨 미설정');
      }
      summary.step3.ran = true;
      this.aiAuto.completedSteps.push(3);

      // 사용자 요청: 3단계가 완료되면 1, 2단계도 자동 완료 처리 (이미 push 되어있음, 보장 차원)
      if (this.aiAuto.completedSteps.indexOf(1) === -1) this.aiAuto.completedSteps.push(1);
      if (this.aiAuto.completedSteps.indexOf(2) === -1) this.aiAuto.completedSteps.push(2);

      this.aiAuto.currentStep = 4;
      this.aiAuto.completedAt = Date.now();
      const elapsedSec = Math.round((this.aiAuto.completedAt - this.aiAuto.startedAt) / 1000);
      this.aiAuto.summary = Object.assign({}, summary, { durationSec: elapsedSec });
      this.aiLog(0, `🎉 AI 자동 설치 완료 — ${elapsedSec}초 소요`, 'success');
      toast.success('AI 자동 설치가 완료되었습니다!');
      // 데이터 카운트 새로고침 (백그라운드)
      try { this.getInstallationProgress(); } catch(e) {}
    } catch (e) {
      console.error('[runAiAutoSetup] error:', e);
      this.aiAuto.completedAt = Date.now();
      const elapsedSec = Math.round((this.aiAuto.completedAt - this.aiAuto.startedAt) / 1000);
      this.aiAuto.summary = Object.assign({}, summary, { durationSec: elapsedSec, aborted: true, abortMessage: e.message });
      toast.error('AI 자동 처리 오류: ' + (e.message || ''));
      this.aiLog(this.aiAuto.currentStep, '오류로 중단됨: ' + (e.message || ''), 'error');
    } finally {
      this.aiAuto.running = false;
    }
  };

  // syncAllReviewsAtOnce 의 confirm 없는 버전 (AI 자동 처리용)
  runAllReviewsForAi = async () => {
    let _this = this;
    if (this.bulkSyncRunning) return;

    this.bulkSyncRunning = true;
    this.bulkSyncCancelRequested = false;
    this.bulkSyncProgress = { rangeIndex: 0, totalFetched: 0, zeroStreak: 0, currentStart: '', currentEnd: '', lastInsert: 0 };

    const periodValue = this.serarchPeriod[0];
    const periodUnit  = this.serarchPeriod[1];
    const baseData = {
      store_id: this.store._id,
      shopNo: this.teamUser.selShopNo || 1,
      getType: 'period'
    };

    let cursorEnd = moment();
    const STOP_AT_ZERO_STREAK = 3;
    const HARD_LIMIT_RANGES = 200;

    try {
      while (!this.bulkSyncCancelRequested && !this.aiAuto.cancel && this.bulkSyncProgress.rangeIndex < HARD_LIMIT_RANGES) {
        const rangeEnd = cursorEnd.clone();
        const rangeStart = cursorEnd.clone().add(-periodValue, periodUnit).add(1, 'days');
        const params = {
          startDate: rangeStart.format('YYYY-MM-DD'),
          endDate:   rangeEnd.format('YYYY-MM-DD'),
          isOverwrite: false
        };
        this.bulkSyncProgress.currentStart = params.startDate;
        this.bulkSyncProgress.currentEnd   = params.endDate;
        this.bulkSyncProgress.rangeIndex += 1;

        const data = Object.assign({}, baseData, { params });
        const res = await new Promise(resolve => { _this.props.setReviewSync(data, resolve); });

        const inserted = (res && res.data && typeof res.data.insertReviewCount === 'number') ? res.data.insertReviewCount : 0;
        this.bulkSyncProgress.lastInsert = inserted;
        this.bulkSyncProgress.totalFetched += inserted;
        if (inserted === 0) this.bulkSyncProgress.zeroStreak += 1;
        else this.bulkSyncProgress.zeroStreak = 0;

        cursorEnd = rangeStart.clone().add(-1, 'days');
        if (this.bulkSyncProgress.zeroStreak >= STOP_AT_ZERO_STREAK) break;
        if (cursorEnd.year() < 2010) break;
      }
      this.getInstallationProgress();
    } finally {
      this.bulkSyncRunning = false;
    }
  };

  @action
  setProductSync = async () => {
    let _this = this;
    if(! await this.checkPaidUser(_this.store)) return false;

    _this.isLoading = true;
    let data = {
      store_id: _this.store._id,
      shopNo: _this.teamUser.selShopNo,
      teamUser_id: _this.teamUser.id,
    }

    _this.props.setProductSync(data, function(res) {
      _this.isLoading = false;
      if(res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      }
      else {
        toast(res.data.productCount + "상품 동기화가 완료되었습니다.");
        // Update product count after sync
        _this.productCount = res.data.productCount;
      }
    });

    for (let i = 0; i < localStorage.length; i++) {
      if(localStorage.key(i).indexOf("goodList_" + this.store.platformId) > -1 ) {
        localStorage.removeItem(localStorage.key(i));
      }
    }

  };

  @action
  selectPeriod = async (num, type) => {
    let _this = this;
    let selPeriod = [];
    selPeriod[0] = num;
    selPeriod[1] = type;

    if(type === "max") {
      let data = {
        store_id: this.store._id,
        shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
        flatform: 'cafe24'
      }

      this.props.getStatusReviewBoard(data, function(res) {
        if(res && res.data) {
          console.log(res.data);
          _this.modals.data = res.data;
          if(res.data.selectPeriod[1] === "years") {
            res.data.selectPeriod[2] = res.data.selectPeriod[0] + "년";
          }
          else if(res.data.selectPeriod[1] === "months") {
            res.data.selectPeriod[2] = res.data.selectPeriod[0] + "달";
          }
          else if(res.data.selectPeriod[1] === "weeks") {
            res.data.selectPeriod[2] = res.data.selectPeriod[0] + "주";
          }
          else if(res.data.selectPeriod[1] === "days") {
            res.data.selectPeriod[2] = res.data.selectPeriod[0] + "일";
          }
          _this.serarchPeriod = res.data.selectPeriod;
          _this.syncReviewValue.startDate = moment().add(-res.data.selectPeriod[0], res.data.selectPeriod[1]).add(1, 'days').format('yyyy-MM-DD');
        }
      });
    }
    else {
      if(type === "years") {
        selPeriod[2] = num + "년";
      }
      else if(type === "months") {
        selPeriod[2] = num + "달";
      }
      else if(type === "weeks") {
        selPeriod[2] = num + "주";
      }
      else if(type === "days") {
        selPeriod[2] = num + "일";
      }
      this.serarchPeriod = selPeriod;
      this.syncReviewValue.startDate = moment().add(-selPeriod[0], selPeriod[1]).add(1, 'days').format('yyyy-MM-DD');
    }


  };

  @action
  /**
   * 전체 리뷰 한번에 가져오기 (신규 가입 고객용)
   * - 오늘부터 거꾸로 serarchPeriod[0] serarchPeriod[1] (예: 3개월) 단위로 순차 호출
   * - insertReviewCount === 0 이 연속 3번 발생하면 중지
   * - 사용자가 취소하면 중지
   */
  syncAllReviewsAtOnce = async () => {
    let _this = this;
    if (this.bulkSyncRunning) return;
    if (!await this.checkPaidUser(this.store)) return false;
    if (!window.confirm('처음부터 끝까지 모든 리뷰를 한번에 가져옵니다.\n시간이 다소 걸릴 수 있으며 중간에 멈추려면 "중지" 버튼을 눌러 주세요.\n계속할까요?')) return;

    this.bulkSyncRunning = true;
    this.bulkSyncCancelRequested = false;
    this.bulkSyncProgress = {rangeIndex: 0, totalFetched: 0, zeroStreak: 0, currentStart: '', currentEnd: '', lastInsert: 0};

    const periodValue = this.serarchPeriod[0]; // 예: 3
    const periodUnit  = this.serarchPeriod[1]; // 예: 'months'
    const baseData = {
      store_id: this.store._id,
      shopNo: this.teamUser.selShopNo || 1,
      getType: 'period'
    };

    let cursorEnd = moment(); // 오늘부터 시작 (가장 최근)
    const STOP_AT_ZERO_STREAK = 3;
    const HARD_LIMIT_RANGES = 200; // 안전장치

    try {
      while (!this.bulkSyncCancelRequested && this.bulkSyncProgress.rangeIndex < HARD_LIMIT_RANGES) {
        const rangeEnd = cursorEnd.clone();
        const rangeStart = cursorEnd.clone().add(-periodValue, periodUnit).add(1, 'days');
        const params = {
          startDate: rangeStart.format('YYYY-MM-DD'),
          endDate:   rangeEnd.format('YYYY-MM-DD'),
          isOverwrite: false
        };

        this.bulkSyncProgress.currentStart = params.startDate;
        this.bulkSyncProgress.currentEnd   = params.endDate;
        this.bulkSyncProgress.rangeIndex += 1;

        const data = Object.assign({}, baseData, {params});

        const res = await new Promise(resolve => {
          _this.props.setReviewSync(data, resolve);
        });

        // 서버가 설정 누락 등으로 에러를 반환하면 0건 반복으로 오인하지 않고 즉시 중단
        if (res && res.data && res.data.e) {
          toast.error('리뷰 가져오기에 실패했습니다: ' + res.data.e);
          break;
        }

        const inserted = (res && res.data && typeof res.data.insertReviewCount === 'number')
          ? res.data.insertReviewCount : 0;
        this.bulkSyncProgress.lastInsert = inserted;
        this.bulkSyncProgress.totalFetched += inserted;
        if (inserted === 0) {
          this.bulkSyncProgress.zeroStreak += 1;
        } else {
          this.bulkSyncProgress.zeroStreak = 0;
        }

        // 다음 구간: 더 과거로 (cursorEnd 를 rangeStart - 1일 로 이동)
        cursorEnd = rangeStart.clone().add(-1, 'days');

        // 종료 조건: 연속 3번 0건
        if (this.bulkSyncProgress.zeroStreak >= STOP_AT_ZERO_STREAK) break;
        // 안전: 너무 과거(2010년 이전)면 중지
        if (cursorEnd.year() < 2010) break;
      }

      const cancelled = this.bulkSyncCancelRequested;
      const total = this.bulkSyncProgress.totalFetched;
      if (cancelled) {
        toast.warn(`전체 리뷰 가져오기 중지됨 — 누적 ${total.toLocaleString()}건`);
      } else if (this.bulkSyncProgress.zeroStreak >= STOP_AT_ZERO_STREAK) {
        toast.success(`전체 리뷰 가져오기 완료 — 누적 ${total.toLocaleString()}건 (연속 0건 ${STOP_AT_ZERO_STREAK}회로 종료)`);
      } else {
        toast.success(`전체 리뷰 가져오기 완료 — 누적 ${total.toLocaleString()}건`);
      }
      this.getInstallationProgress();
    } catch (e) {
      console.error('[syncAllReviewsAtOnce] error:', e);
      toast.error('전체 리뷰 가져오기 중 오류: ' + (e.message || ''));
    } finally {
      this.bulkSyncRunning = false;
    }
  };

  cancelBulkSync = () => {
    if (!this.bulkSyncRunning) return;
    if (window.confirm('진행 중인 가져오기를 중지하시겠습니까?')) {
      this.bulkSyncCancelRequested = true;
    }
  };

  setReviewSync = async (type) => {
    let _this = this;
    if(! await this.checkPaidUser(_this.store)) return false;
    _this.isLoading = true;

    let data = {
      store_id: _this.store._id,
      shopNo: this.teamUser.selShopNo || 1,
      getType: type || 'new',
      // data.params 는 아래에서 설정
    };

    const getMonthlyRanges = (start, end) => {
      let ranges = [];
      end = moment(end).add(1, 'days')
      let current = moment(start);
      const last = moment(end);

      if ( last.diff(current, 'months', true) <= 2 ) {
        ranges =  [{
          startDate: current.format('YYYY-MM-DD'),
          endDate:   last.format('YYYY-MM-DD'),
        }];
      }
      else {
        while (current.isBefore(last) || current.isSame(last, 'day')) {
          // 2개월 뒤 하루 전을 계산
          let monthEnd = current.clone().add(2, 'months').subtract(1, 'day');
          // 범위를 벗어나면 end 값으로 고정
          if (monthEnd.isAfter(last)) {
            monthEnd = last.clone();
          }

          ranges.push({
            startDate: current.format('YYYY-MM-DD'),
            endDate:   monthEnd.format('YYYY-MM-DD'),
          });

          // 다음 구간 시작은 이전 구간 종료 다음 날
          current = monthEnd.clone().add(1, 'day');
        }
      }

      return ranges;


    };

    if (type === 'period') {
      // 기간 유효성 검사
      if (!isOverPeriod(this.syncReviewValue.startDate, this.syncReviewValue.endDate, this.serarchPeriod)) {
        alert('최대 ' + this.serarchPeriod[2] + '단위로 선택해 주세요.');
        _this.isLoading = false;
        return false;
      }
      // 월 단위로 분할해서 순차 호출
      const ranges = getMonthlyRanges(this.syncReviewValue.startDate, this.syncReviewValue.endDate);
      for (const params of ranges) {
        data.params = params;

        // 콜백 기반 API를 Promise로 감싸서 await 가능하게
        const res = await new Promise(resolve => {
          _this.props.setReviewSync(data, resolve);
        });
        if (res && res.data) {
          if (res.data.e) {
            toast.error('리뷰 가져오기에 실패했습니다: ' + res.data.e);
            break;
          }
          toast(
              moment(res.data.startDate).format('YYYY-MM-DD')
              + ' ~ '
              + moment(res.data.endDate).format('YYYY-MM-DD')
              + ' 기간의 리뷰가 '
              + res.data.insertReviewCount
              + '개 업데이트 되었습니다.'
          );
        }
      }
      // Update review count after sync
      _this.getInstallationProgress();
    } else {
      // 기존 단일 호출 로직
      data.params = this.syncReviewValue;
      await new Promise(resolve => {
        _this.props.setReviewSync(data, resolve);
      }).then(res => {
        if (res && res.data) {
          if (res.data.e) {
            toast.error('리뷰 가져오기에 실패했습니다: ' + res.data.e);
            return;
          }
          toast(
              moment(res.data.startDate).format('YYYY-MM-DD')
              + ' ~ '
              + moment(res.data.endDate).format('YYYY-MM-DD')
              + ' 기간의 리뷰가 '
              + res.data.insertReviewCount
              + '개 업데이트 되었습니다.'
          );
        }
      });
      // Update review count after sync
      _this.getInstallationProgress();
    }
    _this.isLoading = false;
  };

  @action
  modalToggle = function(target, data) {
    this.modals[target] = !this.modals[target];
    if(!target) {
      for( var i in this.modals) {
        this.modals[i] = false;
      }
    }

    if(target === 'isCafeSettingModal') {
      // if(!this.isUse) {
      //   alert('사용권한이 없습니다.');
      //   return false;
      // }
      if(this.skins.length === 0) {
        this.getApplySkins(true);
      }
    }

    if(data) {
      if(target === 'isCafeSettingModal' && data) {
        this.modals.widgetData.product = data;
      }
      else {
        this.modals.data = data;
      }
    }

    if(target === 'isSyncReview') {
      this.selectPeriod(1, 'days');
    }

  };



  onChangeSyncReviewValue = async (event, obj) => {
    const { name, value, type } = event.target;
    let newValue;
    if(type === 'checkbox') {
      if(value) {
        newValue = !JSON.parse(value);
      }
      else {
        newValue = true;
      }
    }
    else {
      newValue = value;
    }

    if(obj) {
      obj[name] = newValue;

      if(name === 'all') {
        for(let key in obj) {
          obj[key] = newValue;
        }
      }
      else {
        let isAll = false;
        if(newValue) {
          isAll = true;
          for(let key in obj) {
            if(!obj[key] && key !== 'all') {
              isAll = false;
              break;
            }
          }
        }
        obj['all'] = isAll;
      }
    }
    else {
      this.syncReviewValue[name] = newValue;
    }

  };


  onChangeCalendarValueForRS = async (date, dateType) => {
    this.isShowCalendarForRS = {
      startDate: false,
      endDate: false,
    };
    this.syncReviewValue[dateType] = moment(date).format('yyyy-MM-DD');
    // if((this.syncReviewValue.startDate || this.syncReviewValue.endDate) && !isOverPeriod(this.syncReviewValue.startDate, this.syncReviewValue.endDate, this.serarchPeriod)) {
    //   alert('최대 ' + this.serarchPeriod[2]  + '로 선택해 주세요.');
    //
    // }
  }



  render() {

    function skinLanguageCodeKR (code) {
      switch (code) {
        case 'ko_KR':
          return '국문';
        case 'en_US':
          return '영문';
        case 'zh_CN':
          return '중문(간체)';
        case 'zh_TW':
          return '중문(번체)';
        case 'ja_JP':
          return '일문';
        case 'pt_PT':
          return '포르투갈어';
        case 'es_ES':
          return '스페인어';
        case 'vi_VN':
          return '베트남어';
        default:
          return code;

      }
    }

    // === Step 완료 여부 — 데이터 카운트 OR AI가 완료한 단계 ===
    const aiDone = (n) => this.aiAuto && this.aiAuto.completedSteps && this.aiAuto.completedSteps.indexOf(n) !== -1;
    const step1Done = this.productCount > 0 || aiDone(1);
    const step3Done = this.activeSkinCount > 0 || aiDone(3);
    // 3단계가 완료되면 2단계는 리뷰 0건이어도 완료로 간주 (스킨 활성화 시점에 리뷰는 이미 동기화 완료된 상태)
    const step2Done = this.reviewCount > 0 || aiDone(2) || step3Done;
    const completedCount = (step1Done ? 1 : 0) + (step2Done ? 1 : 0) + (step3Done ? 1 : 0);

    return (
      <>
      <div className="main-content">
          <PageTitle />

          {(this.isLogin && this.teamUser && !this.teamUser.isPaidShop) && (
            <div className="es-paywall-banner">
              <FeatherIcon icon="lock" size="14"/>
              <span><strong>설정 화면은 무료로 확인</strong>할 수 있습니다. 설정 변경 / 저장 / 적용은 <strong>유료 플랜 전용</strong>입니다.</span>
              <button type="button" className="es-paywall-banner__cta"
                      onClick={() => { window.location.href = '/inAppOrder'; }}>
                <FeatherIcon icon="credit-card" size="13"/>
                결제페이지로 이동하기
                <FeatherIcon icon="arrow-right" size="13"/>
              </button>
            </div>
          )}

          {( this.isLogin && this.teamUser.emailId ) ?
            <div className="write-post-box">

              {/* Installation Progress Tracker - Premium UI/UX Design */}
              <div style={{marginBottom: '30px'}}>
                <div style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  padding: '30px',
                  borderRadius: '16px',
                  boxShadow: '0 10px 40px rgba(102, 126, 234, 0.2)',
                  marginBottom: '10px'
                }}>
                  <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
                    <div>
                      <h3 style={{color: 'white', margin: 0, fontSize: '24px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: 8}}>
                        설치 진행 상황
                        <HelpButton tourKey="easySetting" />
                      </h3>
                      <p style={{color: 'rgba(255,255,255,0.9)', margin: '5px 0 0 0', fontSize: '14px'}}>
                        사전 설정(2)과 설치 단계(3)를 완료하여 온리플 서비스를 시작하세요
                      </p>
                    </div>
                    <div style={{
                      backgroundColor: 'rgba(255,255,255,0.2)',
                      padding: '10px 20px',
                      borderRadius: '20px',
                      backdropFilter: 'blur(10px)'
                    }}>
                      <span style={{color: 'white', fontSize: '14px', fontWeight: '600'}}>
                        설치: {completedCount}/3 단계
                      </span>
                    </div>
                  </div>

                  {/* ===== AI 자동 설치 — 1, 2, 3 단계를 한번에 자동 처리 ===== */}
                  {(() => {
                    const remaining = (step1Done ? 0 : 1) + (step2Done ? 0 : 1) + (step3Done ? 0 : 1);
                    if (remaining === 0 && !this.aiAuto.running && this.aiAuto.log.length === 0) return null;
                    const stepLabel = (n) => ({1: '상품 가져오기', 2: '전체 리뷰 가져오기', 3: '스킨 활성화', 4: '완료'}[n] || '대기');
                    const logColor = (t) => ({success: '#34D399', error: '#F87171', warn: '#FBBF24', skip: '#9CA3AF', info: 'rgba(255,255,255,0.85)'}[t] || 'white');
                    return (
                      <div id="esAiAutoBox" style={{
                        background: 'linear-gradient(135deg, rgba(0,242,254,0.18) 0%, rgba(79,172,254,0.18) 100%)',
                        border: '1px solid rgba(255,255,255,0.35)',
                        borderRadius: 12,
                        padding: '16px 18px',
                        marginBottom: 20
                      }}>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap'}}>
                          <div style={{display: 'flex', alignItems: 'center', gap: 12, flex: 1, minWidth: 0}}>
                            <div style={{
                              width: 44, height: 44, borderRadius: 12, flexShrink: 0,
                              background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                              display: 'flex', alignItems: 'center', justifyContent: 'center',
                              boxShadow: '0 4px 14px rgba(0,242,254,0.4)'
                            }}>
                              <FeatherIcon icon="zap" size="22" style={{color: 'white'}} />
                            </div>
                            <div style={{minWidth: 0}}>
                              <div style={{color: 'white', fontSize: 16, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 6}}>
                                <span role="img" aria-label="ai">🤖</span> AI 자동 설치
                                {this.aiAuto.running && (
                                  <span style={{
                                    fontSize: 11, padding: '2px 8px', borderRadius: 999,
                                    background: 'rgba(255,255,255,0.25)', color: 'white', fontWeight: 700
                                  }}>{stepLabel(this.aiAuto.currentStep)} 진행 중…</span>
                                )}
                                {!this.aiAuto.running && this.aiAuto.currentStep === 4 && (
                                  <span style={{
                                    fontSize: 11, padding: '2px 8px', borderRadius: 999,
                                    background: '#34D399', color: 'white', fontWeight: 700
                                  }}>완료</span>
                                )}
                              </div>
                              <div style={{color: 'rgba(255,255,255,0.9)', fontSize: 12, marginTop: 2}}>
                                {remaining > 0
                                  ? <>남은 <strong>{remaining}개 단계</strong>를 클릭 한 번으로 자동 처리합니다 (① 상품 → ② 전체 리뷰 → ③ PC/모바일 스킨 활성화)</>
                                  : '모든 단계가 완료되었습니다.'}
                              </div>
                            </div>
                          </div>
                          <div style={{display: 'flex', gap: 8, flexShrink: 0}}>
                            {!this.aiAuto.running && remaining > 0 && (
                              <Button
                                onClick={() => this.runAiAutoSetup()}
                                style={{
                                  padding: '10px 18px', fontSize: 14, fontWeight: 700,
                                  borderRadius: 8, border: 'none',
                                  background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                                  color: 'white', cursor: 'pointer',
                                  boxShadow: '0 4px 14px rgba(0,242,254,0.45)',
                                  display: 'inline-flex', alignItems: 'center', gap: 6
                                }}>
                                <FeatherIcon icon="zap" size="15" /> AI로 자동 설치 시작 ({remaining}단계)
                              </Button>
                            )}
                            {this.aiAuto.running && (
                              <Button
                                onClick={() => { this.aiAuto.cancel = true; this.bulkSyncCancelRequested = true; }}
                                style={{
                                  padding: '10px 18px', fontSize: 14, fontWeight: 700,
                                  borderRadius: 8, border: '1px solid rgba(255,255,255,0.5)',
                                  background: 'rgba(0,0,0,0.2)', color: 'white', cursor: 'pointer',
                                  display: 'inline-flex', alignItems: 'center', gap: 6
                                }}>
                                <FeatherIcon icon="x-octagon" size="15" /> 중지
                              </Button>
                            )}
                          </div>
                        </div>

                        {/* 진행 단계 표시 */}
                        {(this.aiAuto.running || this.aiAuto.log.length > 0) && (
                          <div style={{marginTop: 14}}>
                            <div style={{display: 'flex', gap: 6, marginBottom: 10}}>
                              {[1, 2, 3].map(n => {
                                const isDone = this.aiAuto.completedSteps.indexOf(n) !== -1;
                                const isActive = this.aiAuto.currentStep === n && this.aiAuto.running;
                                const state = isDone ? 'done' : isActive ? 'active' : 'pending';
                                const bg = state === 'done' ? '#34D399' : state === 'active' ? '#FBBF24' : 'rgba(255,255,255,0.2)';
                                const label = stepLabel(n);
                                return (
                                  <div key={n} style={{
                                    flex: 1, padding: '6px 10px', borderRadius: 6,
                                    background: bg, color: 'white', fontSize: 11, fontWeight: 700,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4,
                                    transition: 'all 200ms'
                                  }}>
                                    {state === 'done' && <FeatherIcon icon="check" size="11" />}
                                    {state === 'active' && <FeatherIcon icon="loader" size="11" />}
                                    Step {n}: {label}
                                  </div>
                                );
                              })}
                            </div>

                            {/* 로그 */}
                            <div style={{
                              maxHeight: 160, overflowY: 'auto',
                              background: 'rgba(0,0,0,0.25)', border: '1px solid rgba(255,255,255,0.15)',
                              borderRadius: 6, padding: '8px 10px', fontSize: 11, lineHeight: 1.6,
                              fontFamily: 'Menlo, Consolas, monospace'
                            }}>
                              {this.aiAuto.log.length === 0 ? (
                                <span style={{color: 'rgba(255,255,255,0.6)'}}>로그 대기 중…</span>
                              ) : this.aiAuto.log.map((entry, idx) => (
                                <div key={idx} style={{color: logColor(entry.type), marginBottom: 2}}>
                                  <span style={{color: 'rgba(255,255,255,0.5)'}}>[{entry.time}]</span>{' '}
                                  {entry.step > 0 && <span style={{color: 'rgba(255,255,255,0.7)'}}>Step {entry.step} ·</span>} {entry.msg}
                                </div>
                              ))}
                            </div>

                            {/* 리뷰 가져오기 진행 상황 (Step 2 진행 중일 때) */}
                            {this.aiAuto.running && this.aiAuto.currentStep === 2 && this.bulkSyncProgress && (
                              <div style={{marginTop: 8, fontSize: 11, color: 'rgba(255,255,255,0.85)'}}>
                                <FeatherIcon icon="activity" size="11" />{' '}
                                구간 #{this.bulkSyncProgress.rangeIndex} ({this.bulkSyncProgress.currentStart} ~ {this.bulkSyncProgress.currentEnd}) — 누적 <strong>{this.bulkSyncProgress.totalFetched.toLocaleString()}건</strong>
                              </div>
                            )}
                          </div>
                        )}

                        {/* === 완료 후 처리 요약 === */}
                        {!this.aiAuto.running && this.aiAuto.summary && (() => {
                          const s = this.aiAuto.summary;
                          const fmtDur = (sec) => {
                            if (sec < 60) return `${sec}초`;
                            const m = Math.floor(sec / 60), r = sec % 60;
                            return `${m}분 ${r}초`;
                          };
                          const renderRow = (icon, color, label, content) => (
                            <div style={{display: 'flex', alignItems: 'flex-start', gap: 10, padding: '10px 12px', background: 'rgba(255,255,255,0.95)', borderRadius: 8, marginBottom: 6}}>
                              <div style={{
                                width: 28, height: 28, borderRadius: 6, flexShrink: 0,
                                background: color,
                                display: 'flex', alignItems: 'center', justifyContent: 'center'
                              }}>
                                <FeatherIcon icon={icon} size="14" style={{color: 'white'}} />
                              </div>
                              <div style={{flex: 1, minWidth: 0}}>
                                <div style={{fontSize: 12, fontWeight: 700, color: '#1F2937', marginBottom: 2}}>{label}</div>
                                <div style={{fontSize: 12, color: '#4B5563'}}>{content}</div>
                              </div>
                            </div>
                          );
                          return (
                            <div style={{
                              marginTop: 14,
                              background: s.aborted ? 'rgba(248,113,113,0.18)' : 'rgba(52,211,153,0.18)',
                              border: `1px solid ${s.aborted ? 'rgba(248,113,113,0.5)' : 'rgba(52,211,153,0.55)'}`,
                              borderRadius: 10,
                              padding: '14px 16px'
                            }}>
                              <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12, flexWrap: 'wrap', gap: 8}}>
                                <div style={{display: 'flex', alignItems: 'center', gap: 8, color: 'white'}}>
                                  <FeatherIcon icon={s.aborted ? 'alert-triangle' : 'check-circle'} size="18" />
                                  <strong style={{fontSize: 14}}>
                                    {s.aborted ? `AI 자동 처리가 중단됨` : `AI 자동 처리 완료 요약`}
                                  </strong>
                                </div>
                                <div style={{display: 'flex', gap: 8, alignItems: 'center'}}>
                                  <span style={{
                                    padding: '4px 10px', borderRadius: 999,
                                    background: 'rgba(255,255,255,0.25)', color: 'white',
                                    fontSize: 11, fontWeight: 700
                                  }}>
                                    <FeatherIcon icon="clock" size="11" /> 소요 {fmtDur(s.durationSec)}
                                  </span>
                                  <button type="button" onClick={() => { this.aiAuto.summary = null; this.aiAuto.log = []; this.aiAuto.completedSteps = []; this.aiAuto.currentStep = 0; }}
                                    title="요약 닫기"
                                    style={{
                                      width: 24, height: 24, borderRadius: 6, padding: 0,
                                      background: 'rgba(255,255,255,0.2)', border: 'none', color: 'white',
                                      cursor: 'pointer',
                                      display: 'inline-flex', alignItems: 'center', justifyContent: 'center'
                                    }}>
                                    <FeatherIcon icon="x" size="12" />
                                  </button>
                                </div>
                              </div>

                              {/* Step 1 */}
                              {renderRow('shopping-bag', 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                'Step 1 · 상품 가져오기',
                                s.step1.error
                                  ? <span style={{color: '#B91C1C'}}>실패: {s.step1.error}</span>
                                  : s.step1.skipped
                                    ? <>이미 동기화되어 있어 건너뜀 (현재 <strong>{s.step1.count}개</strong>)</>
                                    : <><strong>{s.step1.count}개</strong> 상품을 새로 동기화했습니다.</>
                              )}

                              {/* Step 2 */}
                              {renderRow('message-square', 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                                'Step 2 · 전체 리뷰 가져오기',
                                s.step2.error
                                  ? <span style={{color: '#B91C1C'}}>실패: {s.step2.error}</span>
                                  : s.step2.skipped
                                    ? <>이미 동기화되어 있어 건너뜀 (현재 <strong>{s.step2.count.toLocaleString()}건</strong>)</>
                                    : <><strong>{s.step2.count.toLocaleString()}건</strong>의 리뷰를 가져왔습니다 ({s.step2.ranges}개 기간 구간).</>
                              )}

                              {/* Step 3 */}
                              {renderRow('layers', 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                                'Step 3 · 스킨 활성화',
                                s.step3.ran ? (
                                  <div>
                                    {s.step3.pc ? (
                                      <div>
                                        <strong>PC:</strong> {s.step3.pc.name}
                                        {s.step3.pc.activated ? <span style={{color: '#059669', fontWeight: 700}}> ✓ 활성화 완료</span>
                                          : s.step3.pc.skipped ? <span style={{color: '#6B7280'}}> · 이미 활성화됨</span>
                                          : <span style={{color: '#B91C1C'}}> · 실패</span>}
                                      </div>
                                    ) : <div style={{color: '#92400E'}}>PC 사용 중 스킨을 찾을 수 없음</div>}
                                    {s.step3.mobile ? (
                                      <div>
                                        <strong>Mobile:</strong> {s.step3.mobile.name}
                                        {s.step3.mobile.activated ? <span style={{color: '#059669', fontWeight: 700}}> ✓ 활성화 완료</span>
                                          : s.step3.mobile.skipped ? <span style={{color: '#6B7280'}}> · 이미 활성화됨</span>
                                          : <span style={{color: '#B91C1C'}}> · 실패</span>}
                                      </div>
                                    ) : <div style={{color: '#92400E'}}>모바일 사용 중 스킨을 찾을 수 없음</div>}
                                    {s.step3.errors.length > 0 && (
                                      <div style={{marginTop: 4, color: '#B91C1C', fontSize: 11}}>
                                        ⚠ {s.step3.errors.join(', ')}
                                      </div>
                                    )}
                                  </div>
                                ) : <span style={{color: '#92400E'}}>실행되지 않음</span>
                              )}

                              {s.aborted && (
                                <div style={{marginTop: 8, padding: '8px 10px', background: 'rgba(248,113,113,0.25)', borderRadius: 6, fontSize: 12, color: 'white'}}>
                                  <FeatherIcon icon="alert-circle" size="13" /> 중단 사유: <strong>{s.abortMessage || '알 수 없음'}</strong>
                                </div>
                              )}
                            </div>
                          );
                        })()}
                      </div>
                    );
                  })()}

                  {/* ===== 사전 설정 (준비 단계) — 상품/리뷰 가져오기 전에 권장 ===== */}
                  <div id="esPreSetup" style={{
                    background: 'rgba(255,255,255,0.12)',
                    border: '1px dashed rgba(255,255,255,0.35)',
                    borderRadius: 12,
                    padding: '16px 18px',
                    marginBottom: 20
                  }}>
                    <div style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12}}>
                      <div style={{
                        width: 28, height: 28, borderRadius: 8,
                        background: 'rgba(255,255,255,0.25)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                      }}>
                        <FeatherIcon icon="clipboard" size="15" style={{color: 'white'}} />
                      </div>
                      <div>
                        <div style={{color: 'white', fontSize: 14, fontWeight: 700}}>사전 설정 (권장)</div>
                        <div style={{color: 'rgba(255,255,255,0.85)', fontSize: 12}}>
                          아래 2가지 설정을 먼저 완료한 뒤 <strong>상품 가져오기 / 리뷰 가져오기</strong>를 진행하면 더 정확하게 동작합니다.
                        </div>
                      </div>
                    </div>

                    <Row>
                      {/* Pre-Step 1: 리뷰 작성 설정 */}
                      <Col md="6" style={{marginBottom: 12}}>
                        <div id="esPreStep1" style={{
                          background: 'white', borderRadius: 10, padding: '16px 18px',
                          display: 'flex', alignItems: 'center', gap: 14,
                          boxShadow: '0 2px 10px rgba(0,0,0,0.06)'
                        }}>
                          <div style={{
                            width: 44, height: 44, borderRadius: 10, flexShrink: 0,
                            background: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center'
                          }}>
                            <FeatherIcon icon="edit-3" size="22" style={{color: 'white'}} />
                          </div>
                          <div style={{flex: 1, minWidth: 0}}>
                            <div style={{display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2}}>
                              <span style={{
                                fontSize: 10, fontWeight: 700, padding: '1px 6px',
                                background: '#FEF3C7', color: '#92400E', borderRadius: 999
                              }}>사전 1</span>
                              <strong style={{fontSize: 14, color: '#2d3748'}}>리뷰 작성 설정</strong>
                            </div>
                            <div style={{fontSize: 12, color: '#718096'}}>
                              리뷰 작성 양식·작성 조건 등 리뷰 관련 기본 동작을 먼저 정의해 주세요.
                            </div>
                          </div>
                          <Button
                            onClick={() => this.openConfigIframe('/reviewWriteConfig', '리뷰 작성 설정')}
                            style={{
                              padding: '8px 14px', fontSize: 13, fontWeight: 600,
                              borderRadius: 8, border: 'none',
                              background: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)',
                              color: 'white', flexShrink: 0
                            }}>
                            설정하기 <FeatherIcon icon="external-link" size="13" />
                          </Button>
                        </div>
                      </Col>

                      {/* Pre-Step 2: 마일리지 설정 */}
                      <Col md="6" style={{marginBottom: 12}}>
                        <div id="esPreStep2" style={{
                          background: 'white', borderRadius: 10, padding: '16px 18px',
                          display: 'flex', alignItems: 'center', gap: 14,
                          boxShadow: '0 2px 10px rgba(0,0,0,0.06)'
                        }}>
                          <div style={{
                            width: 44, height: 44, borderRadius: 10, flexShrink: 0,
                            background: 'linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center'
                          }}>
                            <FeatherIcon icon="award" size="22" style={{color: 'white'}} />
                          </div>
                          <div style={{flex: 1, minWidth: 0}}>
                            <div style={{display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2}}>
                              <span style={{
                                fontSize: 10, fontWeight: 700, padding: '1px 6px',
                                background: '#DBEAFE', color: '#1E40AF', borderRadius: 999
                              }}>사전 2</span>
                              <strong style={{fontSize: 14, color: '#2d3748'}}>마일리지 설정</strong>
                            </div>
                            <div style={{fontSize: 12, color: '#718096'}}>
                              리뷰 작성 시 지급할 마일리지 규칙을 먼저 설정해 주세요.
                            </div>
                          </div>
                          <Button
                            onClick={() => this.openConfigIframe('/mileageConfig', '마일리지 설정')}
                            style={{
                              padding: '8px 14px', fontSize: 13, fontWeight: 600,
                              borderRadius: 8, border: 'none',
                              background: 'linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%)',
                              color: 'white', flexShrink: 0
                            }}>
                            설정하기 <FeatherIcon icon="external-link" size="13" />
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  {/* Progress Bar */}
                  <div style={{
                    height: '8px',
                    backgroundColor: 'rgba(255,255,255,0.2)',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    marginBottom: '30px'
                  }}>
                    <div style={{
                      height: '100%',
                      width: `${completedCount * 33.33}%`,
                      background: 'linear-gradient(90deg, #00f260 0%, #0575e6 100%)',
                      transition: 'width 0.5s ease',
                      borderRadius: '10px'
                    }}></div>
                  </div>

                  <Row>
                    {/* Step 1: Product Sync */}
                    <Col md="4" style={{marginBottom: '20px'}}>
                      <div id="esStep1Card" style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        height: '100%',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                        border: step1Done ? '3px solid #00f260' : '3px solid transparent',
                        transition: 'all 0.3s ease',
                        position: 'relative',
                        overflow: 'hidden'
                      }}>
                        {/* Status Badge */}
                        <div style={{
                          position: 'absolute',
                          top: '15px',
                          right: '15px',
                          width: '32px',
                          height: '32px',
                          borderRadius: '50%',
                          backgroundColor: step1Done ? '#00f260' : '#e0e0e0',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          transition: 'all 0.3s ease'
                        }}>
                          {step1Done ? (
                            <FeatherIcon icon="check" size="18" style={{color: 'white'}}/>
                          ) : (
                            <span style={{color: '#999', fontSize: '20px', fontWeight: 'bold'}}>1</span>
                          )}
                        </div>

                        {/* Icon */}
                        <div style={{
                          width: '56px',
                          height: '56px',
                          borderRadius: '12px',
                          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginBottom: '16px'
                        }}>
                          <FeatherIcon icon="shopping-bag" size="28" style={{color: 'white'}}/>
                        </div>

                        <h4 style={{fontSize: '18px', fontWeight: '700', color: '#2d3748', marginBottom: '8px'}}>
                          상품 가져오기
                        </h4>
                        <p style={{fontSize: '14px', color: '#718096', marginBottom: '16px', minHeight: '40px'}}>
                          카페24에서 상품 정보를 동기화합니다
                        </p>

                        {/* Status Info */}
                        <div style={{
                          padding: '12px',
                          backgroundColor: this.productCount > 0 ? '#f0fdf4' : '#f7fafc',
                          borderRadius: '8px',
                          marginBottom: '16px'
                        }}>
                          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                            <span style={{fontSize: '13px', color: '#718096', fontWeight: '500'}}>동기화된 상품</span>
                            <span style={{
                              fontSize: '18px',
                              fontWeight: '700',
                              color: this.productCount > 0 ? '#00f260' : '#a0aec0'
                            }}>
                              {this.productCount}개
                            </span>
                          </div>
                        </div>

                        {/* Action Button */}
                        <Button
                          onClick={event => this.setProductSync()}
                          style={{
                            width: '100%',
                            padding: '12px',
                            fontWeight: '600',
                            fontSize: '14px',
                            borderRadius: '8px',
                            border: 'none',
                            background: this.productCount > 0 ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            color: 'white',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)'
                          }}
                        >
                          <FeatherIcon icon="download" size="16" style={{marginRight: '8px'}}/>
                          {this.productCount > 0 ? '재동기화' : '상품 가져오기'}
                        </Button>
                      </div>
                    </Col>

                    {/* Step 2: Review Sync */}
                    <Col md="4" style={{marginBottom: '20px'}}>
                      <div style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        height: '100%',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                        border: step2Done ? '3px solid #00f260' : '3px solid transparent',
                        transition: 'all 0.3s ease',
                        position: 'relative',
                        overflow: 'hidden'
                      }}>
                        {/* Status Badge */}
                        <div style={{
                          position: 'absolute',
                          top: '15px',
                          right: '15px',
                          width: '32px',
                          height: '32px',
                          borderRadius: '50%',
                          backgroundColor: step2Done ? '#00f260' : '#e0e0e0',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          transition: 'all 0.3s ease'
                        }}>
                          {step2Done ? (
                            <FeatherIcon icon="check" size="18" style={{color: 'white'}}/>
                          ) : (
                            <span style={{color: '#999', fontSize: '20px', fontWeight: 'bold'}}>2</span>
                          )}
                        </div>

                        {/* Icon */}
                        <div style={{
                          width: '56px',
                          height: '56px',
                          borderRadius: '12px',
                          background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginBottom: '16px'
                        }}>
                          <FeatherIcon icon="message-square" size="28" style={{color: 'white'}}/>
                        </div>

                        <h4 style={{fontSize: '18px', fontWeight: '700', color: '#2d3748', marginBottom: '8px'}}>
                          리뷰 가져오기
                        </h4>
                        <p style={{fontSize: '14px', color: '#718096', marginBottom: '16px', minHeight: '40px'}}>
                          카페24에서 고객 리뷰를 동기화합니다
                        </p>

                        {/* Status Info */}
                        <div style={{
                          padding: '12px',
                          backgroundColor: this.reviewCount > 0 ? '#f0fdf4' : '#f7fafc',
                          borderRadius: '8px',
                          marginBottom: '16px'
                        }}>
                          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                            <span style={{fontSize: '13px', color: '#718096', fontWeight: '500'}}>동기화된 리뷰</span>
                            <span style={{
                              fontSize: '18px',
                              fontWeight: '700',
                              color: this.reviewCount > 0 ? '#00f260' : '#a0aec0'
                            }}>
                              {this.reviewCount}개
                            </span>
                          </div>
                        </div>

                        {/* Action Button */}
                        <Button
                          onClick={e => this.modalToggle('isSyncReview')}
                          style={{
                            width: '100%',
                            padding: '12px',
                            fontWeight: '600',
                            fontSize: '14px',
                            borderRadius: '8px',
                            border: 'none',
                            background: this.reviewCount > 0 ? 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' : 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                            color: 'white',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 4px 12px rgba(240, 147, 251, 0.3)'
                          }}
                        >
                          <FeatherIcon icon="download" size="16" style={{marginRight: '8px'}}/>
                          {this.reviewCount > 0 ? '재동기화' : '리뷰 가져오기'}
                        </Button>
                      </div>
                    </Col>

                    {/* Step 3: Skin Activation */}
                    <Col md="4" style={{marginBottom: '20px'}}>
                      <div style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        height: '100%',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                        border: step3Done ? '3px solid #00f260' : '3px solid transparent',
                        transition: 'all 0.3s ease',
                        position: 'relative',
                        overflow: 'hidden'
                      }}>
                        {/* Status Badge */}
                        <div style={{
                          position: 'absolute',
                          top: '15px',
                          right: '15px',
                          width: '32px',
                          height: '32px',
                          borderRadius: '50%',
                          backgroundColor: step3Done ? '#00f260' : '#e0e0e0',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          transition: 'all 0.3s ease'
                        }}>
                          {step3Done ? (
                            <FeatherIcon icon="check" size="18" style={{color: 'white'}}/>
                          ) : (
                            <span style={{color: '#999', fontSize: '20px', fontWeight: 'bold'}}>3</span>
                          )}
                        </div>

                        {/* Icon */}
                        <div style={{
                          width: '56px',
                          height: '56px',
                          borderRadius: '12px',
                          background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginBottom: '16px'
                        }}>
                          <FeatherIcon icon="layers" size="28" style={{color: 'white'}}/>
                        </div>

                        <h4 style={{fontSize: '18px', fontWeight: '700', color: '#2d3748', marginBottom: '8px'}}>
                          스킨 활성화
                        </h4>
                        <p style={{fontSize: '14px', color: '#718096', marginBottom: '16px', minHeight: '40px'}}>
                          온리플 서비스를 활성화합니다
                        </p>

                        {/* Status Info */}
                        <div style={{
                          padding: '12px',
                          backgroundColor: this.activeSkinCount > 0 ? '#f0fdf4' : '#f7fafc',
                          borderRadius: '8px',
                          marginBottom: '16px'
                        }}>
                          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                            <span style={{fontSize: '13px', color: '#718096', fontWeight: '500'}}>활성화된 스킨</span>
                            <span style={{
                              fontSize: '18px',
                              fontWeight: '700',
                              color: this.activeSkinCount > 0 ? '#00f260' : '#a0aec0'
                            }}>
                              {this.activeSkinCount}개
                            </span>
                          </div>
                        </div>

                        {/* Action Button */}
                        <Button
                          onClick={e => this.modalToggle('isCafeSettingModal')}
                          style={{
                            width: '100%',
                            padding: '12px',
                            fontWeight: '600',
                            fontSize: '14px',
                            borderRadius: '8px',
                            border: 'none',
                            background: this.activeSkinCount > 0 ? 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' : 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                            color: 'white',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 4px 12px rgba(79, 172, 254, 0.3)'
                          }}
                        >
                          <FeatherIcon icon="power" size="16" style={{marginRight: '8px'}}/>
                          {this.activeSkinCount > 0 ? '스킨 관리' : '활성화 하기'}
                        </Button>
                      </div>
                    </Col>
                  </Row>

                  {/* Completion Message */}
                  {(step1Done && step2Done && step3Done) && (
                    <div style={{marginTop: '20px'}}>
                      <div style={{
                        padding: '20px',
                        backgroundColor: 'rgba(255,255,255,0.15)',
                        borderRadius: '12px',
                        backdropFilter: 'blur(10px)',
                        border: '2px solid rgba(255,255,255,0.2)',
                        textAlign: 'center',
                        marginBottom: '15px'
                      }}>
                        <FeatherIcon icon="check-circle" size="32" style={{color: '#00f260', marginBottom: '10px'}}/>
                        <h4 style={{color: 'white', margin: '0 0 5px 0', fontSize: '18px', fontWeight: '600'}}>
                          <span role="img" aria-label="celebration">🎉</span> 설치가 완료되었습니다!
                        </h4>
                        <p style={{color: 'rgba(255,255,255,0.9)', margin: 0, fontSize: '14px'}}>
                          이제 온리플 서비스를 사용할 수 있습니다
                        </p>
                      </div>

                      {/* Next Steps - Additional Settings */}
                      <div style={{
                        padding: '20px',
                        backgroundColor: 'rgba(255,255,255,0.15)',
                        borderRadius: '12px',
                        backdropFilter: 'blur(10px)',
                        border: '2px solid rgba(255,255,255,0.2)',
                        marginBottom: '15px'
                      }}>
                        <div style={{display: 'flex', alignItems: 'flex-start'}}>
                          <FeatherIcon icon="settings" size="20" style={{color: '#00f2fe', marginRight: '12px', marginTop: '2px', flexShrink: 0}}/>
                          <div style={{width: '100%'}}>
                            <h5 style={{color: 'white', margin: '0 0 8px 0', fontSize: '16px', fontWeight: '600'}}>
                              다음 단계: 추가 설정하기
                            </h5>
                            <p style={{color: 'rgba(255,255,255,0.9)', margin: '0 0 15px 0', fontSize: '14px', lineHeight: '1.6'}}>
                              원하시는 설정에 맞게 리뷰 서비스를 커스터마이징하세요.
                            </p>

                            {/* Settings Cards Grid */}
                            <div style={{
                              display: 'grid',
                              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                              gap: '10px'
                            }}>
                              {[
                                {
                                  path: '/widgetByPage',
                                  title: '위젯 설정 (페이지별 위젯)',
                                  desc: '쇼핑몰 페이지별로 노출할 위젯 구성',
                                  icon: 'layout',
                                  hover: '#4facfe',
                                  iconBg: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
                                },
                                {
                                  path: '/kakaoMsgSetting',
                                  title: '알림톡 설정',
                                  desc: '카카오 알림톡 발송 설정',
                                  icon: 'message-square',
                                  hover: '#FFCD00',
                                  iconBg: 'linear-gradient(135deg, #FEE500 0%, #FFB800 100%)'
                                },
                                {
                                  path: '/replyWriteConfig',
                                  title: '리뷰 답글 설정',
                                  desc: 'AI 답글 / 자동 답글 설정',
                                  icon: 'corner-down-right',
                                  hover: '#667eea',
                                  iconBg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                }
                              ].map(card => (
                                <div
                                  key={card.path}
                                  onClick={() => this.props.history && this.props.history.push(card.path)}
                                  style={{
                                    padding: '15px',
                                    background: 'rgba(255,255,255,0.9)',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    border: '2px solid transparent'
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                                    e.currentTarget.style.borderColor = card.hover;
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = 'none';
                                    e.currentTarget.style.borderColor = 'transparent';
                                  }}
                                >
                                  <div style={{display: 'flex', alignItems: 'center', marginBottom: '8px'}}>
                                    <div style={{
                                      width: '32px',
                                      height: '32px',
                                      borderRadius: '8px',
                                      background: card.iconBg,
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      marginRight: '10px',
                                      flexShrink: 0
                                    }}>
                                      <FeatherIcon icon={card.icon} size="16" style={{color: 'white'}}/>
                                    </div>
                                    <h6 style={{margin: 0, fontSize: '14px', fontWeight: '600', color: '#2d3748'}}>
                                      {card.title}
                                    </h6>
                                  </div>
                                  <p style={{margin: 0, fontSize: '12px', color: '#718096', lineHeight: '1.4'}}>
                                    {card.desc}
                                  </p>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Installation Support Notice */}
                      <div style={{
                        padding: '20px',
                        backgroundColor: 'rgba(255,255,255,0.15)',
                        borderRadius: '12px',
                        backdropFilter: 'blur(10px)',
                        border: '2px solid rgba(255,255,255,0.2)'
                      }}>
                        <div style={{display: 'flex', alignItems: 'flex-start'}}>
                          <FeatherIcon icon="alert-circle" size="20" style={{color: '#ffd700', marginRight: '12px', marginTop: '2px', flexShrink: 0}}/>
                          <div>
                            <h5 style={{color: 'white', margin: '0 0 8px 0', fontSize: '16px', fontWeight: '600'}}>
                              리뷰가 쇼핑몰에 표시되지 않나요?
                            </h5>
                            <p style={{color: 'rgba(255,255,255,0.9)', margin: '0 0 15px 0', fontSize: '14px', lineHeight: '1.6'}}>
                              설치 진행을 완료했지만 실제 쇼핑몰 상품 상세 페이지에 리뷰 리스트가 적용되지 않는 경우, 아래 방법으로 설치 지원을 요청해 주세요.
                            </p>
                            <div style={{display: 'flex', gap: '10px', flexWrap: 'wrap'}}>
                              <Button
                                onClick={() => window.location.href = '/installationRequest'}
                                style={{
                                  padding: '10px 20px',
                                  fontWeight: '600',
                                  fontSize: '14px',
                                  borderRadius: '8px',
                                  border: 'none',
                                  background: 'white',
                                  color: '#667eea',
                                  transition: 'all 0.3s ease',
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '8px'
                                }}
                              >
                                <FeatherIcon icon="file-text" size="16"/>
                                설치 요청하기
                              </Button>
                              <a
                                href={`https://onnomad.co.kr/embed/chat?service=온리플&id=${encodeURIComponent(this.store.platformId || '')}&shopName=${encodeURIComponent(this.store.name || '')}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  padding: '10px 20px',
                                  fontWeight: '600',
                                  fontSize: '14px',
                                  borderRadius: '8px',
                                  border: 'none',
                                  background: '#FEE500',
                                  color: '#3C1E1E',
                                  transition: 'all 0.3s ease',
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  gap: '8px',
                                  textDecoration: 'none'
                                }}
                              >
                                <FeatherIcon icon="message-circle" size="16"/>
                                상담쳇
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>


              <Modal size="lg" className='modal-review-write-form' open={this.modals.isCafeSettingModal}
                     toggle={() => {}} centered={true}
                     style={{maxWidth: '900px'}}>
                <ModalBody style={{padding: 0, borderRadius: '16px', overflow: 'hidden'}}>
                  {/* Premium Modal Header */}
                  <div style={{
                    background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                    padding: '30px',
                    color: 'white',
                    position: 'relative'
                  }}>
                    <button
                      type="button"
                      aria-label="닫기"
                      onClick={() => this.modals.isCafeSettingModal = false}
                      onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.32)'}
                      onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.18)'}
                      style={{
                        position: 'absolute',
                        top: '18px',
                        right: '18px',
                        width: '34px',
                        height: '34px',
                        borderRadius: '50%',
                        border: 'none',
                        background: 'rgba(255,255,255,0.18)',
                        color: '#FFFFFF',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backdropFilter: 'blur(8px)',
                        transition: 'background 0.15s'
                      }}
                    >
                      <FeatherIcon icon="x" size="18" />
                    </button>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                      <div style={{display: 'flex', alignItems: 'center'}}>
                        <div style={{
                          width: '48px',
                          height: '48px',
                          borderRadius: '12px',
                          background: 'rgba(255,255,255,0.2)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '15px'
                        }}>
                          <FeatherIcon icon="layers" size="24" style={{color: 'white'}}/>
                        </div>
                        <div>
                          <h3 style={{margin: 0, fontSize: '24px', fontWeight: '700'}}>스킨 활성화 관리</h3>
                          <p style={{margin: '5px 0 0 0', fontSize: '14px', opacity: 0.9}}>
                            {this.selShop ? this.selShop.shopName : "쇼핑몰"} - 스킨별 온리플 서비스 활성화
                          </p>
                        </div>
                      </div>
                      <div style={{
                        padding: '8px 16px',
                        borderRadius: '20px',
                        background: 'rgba(255,255,255,0.2)',
                        backdropFilter: 'blur(10px)',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}>
                        활성화: {this.activeSkinCount}개
                      </div>
                    </div>
                  </div>

                  <div style={{padding: '30px', backgroundColor: '#f8f9fa'}}>
                    {/* Info Card */}
                    <div style={{
                      backgroundColor: '#e3f2fd',
                      borderRadius: '12px',
                      padding: '20px',
                      marginBottom: '20px',
                      border: '2px solid #90caf9',
                      display: 'flex',
                      alignItems: 'flex-start'
                    }}>
                      <FeatherIcon icon="info" size="20" style={{color: '#1976d2', marginRight: '12px', marginTop: '2px', flexShrink: 0}}/>
                      <div>
                        <h5 style={{margin: '0 0 8px 0', fontSize: '15px', fontWeight: '600', color: '#1565c0'}}>
                          스킨 활성화 안내
                        </h5>
                        <p style={{margin: 0, fontSize: '13px', color: '#1976d2', lineHeight: '1.6'}}>
                          토글 스위치를 켜면 해당 스킨에 온리플 리뷰 서비스가 자동으로 적용됩니다. 현재 사용 중인 스킨을 우선적으로 활성화해 주세요.
                        </p>
                      </div>
                    </div>

                    {/* Skins List */}
                    <div style={{
                      backgroundColor: 'white',
                      borderRadius: '12px',
                      padding: '24px',
                      marginBottom: '20px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                      maxHeight: '500px',
                      overflowY: 'auto'
                    }}>
                      {this.selShop && this.skins && this.skins.length > 0 ? (
                        <div style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
                          {this.skins.map((item, j) => {
                            const isPcSkin = item.usage_type === 'S' || item.usage_type === 'C' || item.usage_type === 'I';
                            const isMobileSkin = item.usage_type === 'M' || item.usage_type === 'N';
                            const isActiveSkin = item.skin_no === this.selShop.pcSkinNo || item.skin_no === this.selShop.mobileSkinNo;

                            return (
                              <div
                                key={j}
                                style={{
                                  padding: '20px',
                                  borderRadius: '12px',
                                  border: item.isSetScript ? '2px solid #4caf50' : '2px solid #e2e8f0',
                                  background: item.isSetScript ? '#f1f8f4' : 'white',
                                  transition: 'all 0.3s ease',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between'
                                }}
                              >
                                <div style={{flex: 1}}>
                                  <div style={{display: 'flex', alignItems: 'center', marginBottom: '8px', flexWrap: 'wrap', gap: '8px'}}>
                                    {/* Device Badge */}
                                    <span style={{
                                      padding: '4px 12px',
                                      borderRadius: '6px',
                                      fontSize: '12px',
                                      fontWeight: '600',
                                      background: isPcSkin ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                                      color: 'white'
                                    }}>
                                      {isPcSkin ? "PC" : isMobileSkin ? "모바일" : "기타"}
                                    </span>

                                    {/* Active Skin Badge */}
                                    {isActiveSkin && (
                                      <span style={{
                                        padding: '4px 12px',
                                        borderRadius: '6px',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        background: '#ffd54f',
                                        color: '#f57f17',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px'
                                      }}>
                                        <FeatherIcon icon="star" size="12"/>
                                        {item.skin_no === this.selShop.pcSkinNo ? "PC 사용중" : "모바일 사용중"}
                                      </span>
                                    )}

                                    {/* Active Status Badge */}
                                    {item.isSetScript && (
                                      <span style={{
                                        padding: '4px 12px',
                                        borderRadius: '6px',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        background: '#c8e6c9',
                                        color: '#2e7d32',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px'
                                      }}>
                                        <FeatherIcon icon="check-circle" size="12"/>
                                        활성화됨
                                      </span>
                                    )}
                                  </div>

                                  <h5 style={{
                                    margin: '0 0 6px 0',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    color: '#2d3748'
                                  }}>
                                    {item.skin_name}
                                  </h5>

                                  <p style={{
                                    margin: 0,
                                    fontSize: '13px',
                                    color: '#718096'
                                  }}>
                                    언어: {skinLanguageCodeKR(item.language_code)} | 스킨 번호: {item.skin_no}
                                  </p>
                                </div>

                                {/* Toggle Switch */}
                                <div style={{marginLeft: '20px'}}>
                                  <FormCheckbox
                                    toggle
                                    checked={item.isSetScript}
                                    onChange={event => this.onChangeCheckedforApplySkin(event, item, ['isSetScript'])}
                                    style={{transform: 'scale(1.2)'}}
                                  />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <div style={{
                          textAlign: 'center',
                          padding: '40px 20px',
                          color: '#718096'
                        }}>
                          <FeatherIcon icon="inbox" size="48" style={{marginBottom: '16px', opacity: 0.5}}/>
                          <p style={{margin: 0, fontSize: '14px'}}>
                            스킨 목록이 없습니다. 아래 버튼을 클릭하여 스킨 목록을 업데이트하세요.
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Action Buttons */}
                    <div style={{
                      display: 'flex',
                      gap: '12px',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}>
                      <Button
                        onClick={event => this.getApplySkins(true)}
                        style={{
                          padding: '12px 24px',
                          borderRadius: '8px',
                          border: '2px solid #4facfe',
                          background: 'white',
                          color: '#4facfe',
                          fontSize: '14px',
                          fontWeight: '600',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px'
                        }}
                      >
                        <FeatherIcon icon="refresh-cw" size="16"/>
                        스킨 목록 새로고침
                      </Button>

                      <Button
                        onClick={event => this.modals.isCafeSettingModal = false}
                        style={{
                          padding: '12px 24px',
                          borderRadius: '8px',
                          border: 'none',
                          background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                          color: 'white',
                          fontSize: '14px',
                          fontWeight: '600',
                          boxShadow: '0 4px 12px rgba(79, 172, 254, 0.3)',
                          minWidth: '120px'
                        }}
                      >
                        완료
                      </Button>
                    </div>
                  </div>
                </ModalBody>
              </Modal>

              <Modal size="lg" className='modal-review-synk-form' open={this.modals.isSyncReview}
                     toggle={() => {}} centered={true}
                     style={{maxWidth: '800px'}}>
                <ModalBody style={{padding: 0, borderRadius: '16px'}}>
                  {/* Premium Modal Header */}
                  <div style={{
                    background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                    padding: '30px',
                    color: 'white',
                    borderRadius: '16px 16px 0 0',
                    position: 'relative'
                  }}>
                    <button
                      type="button"
                      aria-label="닫기"
                      onClick={() => this.modals.isSyncReview = false}
                      onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.32)'}
                      onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.18)'}
                      style={{
                        position: 'absolute',
                        top: '18px',
                        right: '18px',
                        width: '34px',
                        height: '34px',
                        borderRadius: '50%',
                        border: 'none',
                        background: 'rgba(255,255,255,0.18)',
                        color: '#FFFFFF',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backdropFilter: 'blur(8px)',
                        transition: 'background 0.15s'
                      }}
                    >
                      <FeatherIcon icon="x" size="18" />
                    </button>
                    <div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
                      <div style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '12px',
                        background: 'rgba(255,255,255,0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: '15px'
                      }}>
                        <FeatherIcon icon="download-cloud" size="24" style={{color: 'white'}}/>
                      </div>
                      <div>
                        <h3 style={{margin: 0, fontSize: '24px', fontWeight: '700'}}>리뷰 가져오기</h3>
                        <p style={{margin: '5px 0 0 0', fontSize: '14px', opacity: 0.9}}>
                          카페24에서 고객 리뷰를 동기화하세요
                        </p>
                      </div>
                    </div>
                  </div>

                  <div style={{padding: '30px', backgroundColor: '#f8f9fa'}}>

                    {/* === 신규 고객 전용: 전체 리뷰 한번에 가져오기 (로컬 개발 환경에서는 항상 노출) === */}
                    {(this.reviewCount === 0 || this.bulkSyncRunning || (typeof window !== 'undefined' && window.location && window.location.hostname === 'localhost')) && (
                      <div style={{
                        background: 'linear-gradient(135deg, #f0f7ff 0%, #f5f3ff 100%)',
                        border: '1px solid #c7d2fe',
                        borderRadius: '12px',
                        padding: '20px 24px',
                        marginBottom: '20px',
                        boxShadow: '0 2px 8px rgba(79, 70, 229, 0.08)'
                      }}>
                        <div style={{display: 'flex', alignItems: 'flex-start', gap: 14}}>
                          <div style={{flexShrink: 0, width: 44, height: 44, borderRadius: 10, background: '#4A6CF7', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <FeatherIcon icon="cloud-download" size="22" style={{color: 'white'}}/>
                          </div>
                          <div style={{flex: 1, minWidth: 0}}>
                            <div style={{fontSize: 15, fontWeight: 700, color: '#1F2937'}}>
                              전체 리뷰 한번에 가져오기
                              <span style={{marginLeft: 8, fontSize: 11, color: '#4A6CF7', background: '#EEF2FF', padding: '2px 8px', borderRadius: 100, fontWeight: 600}}>NEW</span>
                            </div>
                            <p style={{margin: '4px 0 0', fontSize: 12, color: '#4B5563', lineHeight: 1.5}}>
                              처음 가입하셨다면 이 버튼으로 전체 기간의 리뷰를 한 번에 동기화하세요.<br/>
                              {this.serarchPeriod[2]} 단위로 거꾸로 거슬러 올라가며 자동 호출되고, <b>연속 3회 0건</b>이면 자동 종료됩니다.
                            </p>

                            {/* 진행 상태 */}
                            {this.bulkSyncRunning && (
                              <div style={{marginTop: 12, padding: '10px 12px', background: 'rgba(255,255,255,0.85)', border: '1px solid #C7D2FE', borderRadius: 8, fontSize: 12, color: '#1E40AF'}}>
                                <div style={{display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4}}>
                                  <FeatherIcon icon="loader" size="13"/>
                                  <b>처리 중…</b>
                                  <span style={{marginLeft: 'auto', color: '#4A6CF7'}}>
                                    범위 #{this.bulkSyncProgress.rangeIndex} · 누적 {this.bulkSyncProgress.totalFetched.toLocaleString()}건
                                  </span>
                                </div>
                                <div style={{fontSize: 11, color: '#4B5563'}}>
                                  현재 구간: <b>{this.bulkSyncProgress.currentStart}</b> ~ <b>{this.bulkSyncProgress.currentEnd}</b>
                                  {this.bulkSyncProgress.lastInsert > 0 && (
                                    <span style={{marginLeft: 8, color: '#065F46'}}>+ {this.bulkSyncProgress.lastInsert}건</span>
                                  )}
                                  {this.bulkSyncProgress.zeroStreak > 0 && (
                                    <span style={{marginLeft: 8, color: '#92400E'}}>0건 연속 {this.bulkSyncProgress.zeroStreak}/3</span>
                                  )}
                                </div>
                              </div>
                            )}

                            {/* 액션 버튼 */}
                            <div style={{marginTop: 14, display: 'flex', gap: 8}}>
                              {!this.bulkSyncRunning ? (
                                <Button
                                  onClick={() => this.syncAllReviewsAtOnce()}
                                  style={{
                                    padding: '10px 20px',
                                    borderRadius: 8,
                                    border: 'none',
                                    background: 'linear-gradient(135deg, #4A6CF7 0%, #6366F1 100%)',
                                    color: 'white',
                                    fontSize: 13,
                                    fontWeight: 700,
                                    boxShadow: '0 4px 12px rgba(79, 70, 229, 0.25)',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 6
                                  }}>
                                  <FeatherIcon icon="download-cloud" size="15"/>
                                  전체 리뷰 가져오기 시작
                                </Button>
                              ) : (
                                <Button
                                  onClick={() => this.cancelBulkSync()}
                                  disabled={this.bulkSyncCancelRequested}
                                  style={{
                                    padding: '10px 20px',
                                    borderRadius: 8,
                                    border: '1px solid #DC2626',
                                    background: '#FFFFFF',
                                    color: '#DC2626',
                                    fontSize: 13,
                                    fontWeight: 700,
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 6
                                  }}>
                                  <FeatherIcon icon={this.bulkSyncCancelRequested ? 'loader' : 'x-octagon'} size="15"/>
                                  {this.bulkSyncCancelRequested ? '중지 중…' : '중지'}
                                </Button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Date Selection Section */}
                    <div style={{
                      backgroundColor: 'white',
                      borderRadius: '12px',
                      padding: '24px',
                      marginBottom: '20px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
                    }}>
                      <div style={{display: 'flex', alignItems: 'center', marginBottom: '20px'}}>
                        <FeatherIcon icon="calendar" size="20" style={{color: '#f5576c', marginRight: '10px'}}/>
                        <h4 style={{margin: 0, fontSize: '16px', fontWeight: '600', color: '#2d3748'}}>
                          기간 선택
                          <span style={{
                            marginLeft: '10px',
                            fontSize: '13px',
                            color: '#718096',
                            fontWeight: '400'
                          }}>
                            (최대 {this.serarchPeriod[2]}단위)
                          </span>
                        </h4>
                      </div>

                      {/* Date Pickers */}
                      <Row style={{marginBottom: '15px'}}>
                        <Col md="5">
                          <label style={{
                            display: 'block',
                            fontSize: '13px',
                            fontWeight: '600',
                            color: '#4a5568',
                            marginBottom: '8px'
                          }}>
                            시작일
                          </label>
                          <div className="calendar-box" style={{position: 'relative'}}>
                            <div className="calendar-wrap">
                              <FormInput
                                disabled={this.isWidgetMode}
                                name="startDate"
                                placeholder="YYYY-MM-DD"
                                onChange={event => {
                                  this.onChangeSyncReviewValue(event)
                                }}
                                value={this.syncReviewValue.startDate}
                                onClick={() => {
                                  this.isShowCalendarForRS.endDate = false;
                                  this.isShowCalendarForRS.startDate = !this.isShowCalendarForRS.startDate;
                                }}
                                style={{
                                  padding: '12px 16px',
                                  borderRadius: '8px',
                                  border: '2px solid #e2e8f0',
                                  fontSize: '14px',
                                  fontWeight: '500',
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease'
                                }}
                              />
                              {this.isShowCalendarForRS.startDate ? (
                                <Calendar
                                  value={moment(this.syncReviewValue.startDate).toDate()}
                                  className="startDate"
                                  onChange={date => {
                                    this.onChangeCalendarValueForRS(date, 'startDate')
                                  }}
                                  maxDate={new Date()}
                                />
                              ) : null}
                            </div>
                          </div>
                        </Col>
                        <Col md="2" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '28px'}}>
                          <FeatherIcon icon="arrow-right" size="20" style={{color: '#cbd5e0'}}/>
                        </Col>
                        <Col md="5">
                          <label style={{
                            display: 'block',
                            fontSize: '13px',
                            fontWeight: '600',
                            color: '#4a5568',
                            marginBottom: '8px'
                          }}>
                            종료일
                          </label>
                          <div className="calendar-wrap" style={{position: 'relative'}}>
                            <FormInput
                              disabled={this.isWidgetMode}
                              name="endDate"
                              placeholder="YYYY-MM-DD"
                              onChange={event => {
                                this.onChangeSyncReviewValue(event)
                              }}
                              value={this.syncReviewValue.endDate}
                              onClick={() => {
                                this.isShowCalendarForRS.startDate = false;
                                this.isShowCalendarForRS.endDate = !this.isShowCalendarForRS.endDate;
                              }}
                              style={{
                                padding: '12px 16px',
                                borderRadius: '8px',
                                border: '2px solid #e2e8f0',
                                fontSize: '14px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease'
                              }}
                            />
                            {this.isShowCalendarForRS.endDate ? (
                              <Calendar
                                value={moment(this.syncReviewValue.startDate).toDate()}
                                onChange={date => {
                                  this.onChangeCalendarValueForRS(date, 'endDate')
                                }}
                                maxDate={new Date()}
                              />
                            ) : null}
                          </div>
                        </Col>
                      </Row>

                      {/* Navigation Buttons */}
                      <div style={{
                        display: 'flex',
                        gap: '10px',
                        marginBottom: '15px'
                      }}>
                        <Button
                          onClick={event => {
                            this.syncReviewValue.startDate = moment(this.syncReviewValue.startDate).add(-this.serarchPeriod[0], this.serarchPeriod[1]).format('YYYY-MM-DD');
                            this.syncReviewValue.endDate = moment(this.syncReviewValue.endDate).add(-this.serarchPeriod[0], this.serarchPeriod[1]).format('YYYY-MM-DD');
                          }}
                          style={{
                            padding: '10px 16px',
                            borderRadius: '8px',
                            border: '2px solid #e2e8f0',
                            background: 'white',
                            color: '#4a5568',
                            fontSize: '14px',
                            fontWeight: '600',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                          }}
                        >
                          <FeatherIcon icon="chevron-left" size="16"/>
                          {this.serarchPeriod[2]} 이전
                        </Button>
                        <Button
                          onClick={event => {
                            this.syncReviewValue.startDate = moment(this.syncReviewValue.startDate).add(this.serarchPeriod[0], this.serarchPeriod[1]).format('YYYY-MM-DD');
                            this.syncReviewValue.endDate = moment(this.syncReviewValue.endDate).add(this.serarchPeriod[0], this.serarchPeriod[1]).format('YYYY-MM-DD');
                          }}
                          style={{
                            padding: '10px 16px',
                            borderRadius: '8px',
                            border: '2px solid #e2e8f0',
                            background: 'white',
                            color: '#4a5568',
                            fontSize: '14px',
                            fontWeight: '600',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                          }}
                        >
                          {this.serarchPeriod[2]} 다음
                          <FeatherIcon icon="chevron-right" size="16"/>
                        </Button>
                      </div>

                      {/* Quick Period Selection */}
                      <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '8px'
                      }}>
                        {[
                          { value: 1, unit: 'days', label: '1일' },
                          { value: 2, unit: 'days', label: '2일' },
                          { value: 1, unit: 'weeks', label: '7일' },
                          { value: 2, unit: 'weeks', label: '2주' },
                          { value: 1, unit: 'months', label: '1달' },
                          { value: 1, unit: 'max', label: '최대' }
                        ].map((period, idx) => (
                          <Button
                            key={idx}
                            onClick={e => this.selectPeriod(period.value, period.unit)}
                            style={{
                              padding: '8px 16px',
                              borderRadius: '20px',
                              border: '2px solid #e2e8f0',
                              background: 'white',
                              color: '#4a5568',
                              fontSize: '13px',
                              fontWeight: '600',
                              transition: 'all 0.2s ease',
                              cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.background = 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)';
                              e.target.style.color = 'white';
                              e.target.style.borderColor = 'transparent';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.background = 'white';
                              e.target.style.color = '#4a5568';
                              e.target.style.borderColor = '#e2e8f0';
                            }}
                          >
                            {period.label}
                          </Button>
                        ))}
                      </div>
                    </div>

                    {/* Sync Method: 항상 새로운 리뷰만 추가 방식으로 처리 (isOverwrite: false) */}

                    {/* Action Buttons */}
                    <div style={{
                      display: 'flex',
                      gap: '12px',
                      justifyContent: 'flex-end'
                    }}>
                      <Button
                        onClick={event => this.modals.isSyncReview = false}
                        style={{
                          padding: '12px 24px',
                          borderRadius: '8px',
                          border: '2px solid #e2e8f0',
                          background: 'white',
                          color: '#4a5568',
                          fontSize: '14px',
                          fontWeight: '600',
                          minWidth: '100px'
                        }}
                      >
                        취소
                      </Button>
                      <Button
                        onClick={event => this.setReviewSync('period')}
                        style={{
                          padding: '12px 24px',
                          borderRadius: '8px',
                          border: 'none',
                          background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                          color: 'white',
                          fontSize: '14px',
                          fontWeight: '600',
                          boxShadow: '0 4px 12px rgba(240, 147, 251, 0.3)',
                          minWidth: '140px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '8px'
                        }}
                      >
                        <FeatherIcon icon="download" size="16"/>
                        리뷰 가져오기
                      </Button>
                    </div>
                  </div>
                </ModalBody>
              </Modal>

              {/* Q&A / FAQ Section */}
              <div className="section-box" style={{marginTop: '30px'}}>
                <div style={{
                  background: 'white',
                  borderRadius: '16px',
                  padding: '30px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '25px',
                    borderBottom: '1px solid #e2e8f0',
                    paddingBottom: '20px'
                  }}>
                    <FeatherIcon icon="help-circle" size="24" style={{color: '#2d3748', marginRight: '12px'}}/>
                    <h3 style={{margin: 0, fontSize: '20px', fontWeight: '600', color: '#2d3748'}}>
                      자주 묻는 질문 (FAQ)
                    </h3>
                  </div>

                  {/* FAQ Items */}
                  <div style={{display: 'flex', flexDirection: 'column', gap: '0'}}>

                    {/* FAQ 1: 이 페이지 사용법 */}
                    <div style={{
                      borderBottom: '1px solid #e2e8f0',
                      paddingBottom: '20px',
                      marginBottom: '20px'
                    }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '12px'
                      }}>
                        <span style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '24px',
                          height: '24px',
                          borderRadius: '4px',
                          background: '#2d3748',
                          color: 'white',
                          marginRight: '10px',
                          fontWeight: '700',
                          fontSize: '12px'
                        }}>Q</span>
                        <h4 style={{margin: 0, fontSize: '15px', fontWeight: '600', color: '#2d3748'}}>
                          이 페이지는 어떻게 사용하나요?
                        </h4>
                      </div>
                      <div style={{marginLeft: '34px', color: '#4a5568', lineHeight: '1.7', fontSize: '14px'}}>
                        <p style={{margin: '0 0 12px 0'}}>
                          이 페이지에서는 온리플 서비스 설치를 3단계로 간단하게 완료할 수 있습니다.
                        </p>
                        <ul style={{margin: 0, paddingLeft: '20px'}}>
                          <li style={{marginBottom: '8px'}}>
                            <strong>1단계 - 상품 가져오기:</strong> 카페24에서 상품 정보를 동기화합니다.
                          </li>
                          <li style={{marginBottom: '8px'}}>
                            <strong>2단계 - 리뷰 가져오기:</strong> 카페24에 등록된 고객 리뷰를 가져옵니다.
                          </li>
                          <li style={{marginBottom: '0'}}>
                            <strong>3단계 - 스킨 활성화:</strong> 온리플 서비스를 적용할 스킨을 선택하여 활성화합니다.
                          </li>
                        </ul>
                      </div>
                    </div>

                    {/* FAQ 2: 활성화 후 동작이 되지 않는다면 */}
                    <div style={{
                      borderBottom: '1px solid #e2e8f0',
                      paddingBottom: '20px',
                      marginBottom: '20px'
                    }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '12px'
                      }}>
                        <span style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '24px',
                          height: '24px',
                          borderRadius: '4px',
                          background: '#2d3748',
                          color: 'white',
                          marginRight: '10px',
                          fontWeight: '700',
                          fontSize: '12px'
                        }}>Q</span>
                        <h4 style={{margin: 0, fontSize: '15px', fontWeight: '600', color: '#2d3748'}}>
                          활성화 후 동작이 되지 않는다면?
                        </h4>
                      </div>
                      <div style={{marginLeft: '34px', color: '#4a5568', lineHeight: '1.7', fontSize: '14px'}}>
                        <p style={{margin: '0 0 12px 0'}}>
                          스킨 활성화를 완료했는데도 쇼핑몰에 리뷰가 표시되지 않는 경우, 다음을 확인해 주세요.
                        </p>
                        <ul style={{margin: '0 0 12px 0', paddingLeft: '20px'}}>
                          <li style={{marginBottom: '6px'}}>
                            현재 <strong>사용 중인 스킨</strong>이 활성화되어 있는지 확인하세요. (PC/모바일 각각)
                          </li>
                          <li style={{marginBottom: '6px'}}>
                            카페24 관리자에서 <strong>캐시를 삭제</strong>해 주세요.
                          </li>
                          <li style={{marginBottom: '0'}}>
                            브라우저의 <strong>하드 새로고침</strong>(Ctrl+Shift+R)을 시도해 보세요.
                          </li>
                        </ul>
                        <div style={{
                          padding: '12px 15px',
                          background: '#f7fafc',
                          borderRadius: '6px'
                        }}>
                          <p style={{margin: 0, fontSize: '13px', color: '#4a5568'}}>
                            <strong>그래도 동작하지 않는 경우:</strong> 일부 스킨은 수동 설치가 필요합니다.
                            <a href="/installationRequest" style={{color: '#2d3748', marginLeft: '5px', fontWeight: '600'}}>설치 요청</a> 또는
                            <a href={`https://onnomad.co.kr/embed/chat?service=온리플&id=${encodeURIComponent(this.store.platformId || '')}&shopName=${encodeURIComponent(this.store.name || '')}`} target="_blank" rel="noopener noreferrer" style={{color: '#2d3748', marginLeft: '5px', fontWeight: '600'}}>상담쳇 문의</a>를 해주세요.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* FAQ: 리뷰 가져오기 시 카페24 데이터를 못 가져오는 경우 */}
                    <div style={{
                      borderBottom: '1px solid #e2e8f0',
                      paddingBottom: '20px',
                      marginBottom: '20px'
                    }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '12px'
                      }}>
                        <span style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '24px',
                          height: '24px',
                          borderRadius: '4px',
                          background: '#2d3748',
                          color: 'white',
                          marginRight: '10px',
                          fontWeight: '700',
                          fontSize: '12px'
                        }}>Q</span>
                        <h4 style={{margin: 0, fontSize: '15px', fontWeight: '600', color: '#2d3748'}}>
                          리뷰 가져오기 시 카페24의 리뷰 데이터를 가져오지 못하는 경우?
                        </h4>
                      </div>
                      <div style={{marginLeft: '34px', color: '#4a5568', lineHeight: '1.7', fontSize: '14px'}}>
                        <p style={{margin: '0 0 12px 0'}}>
                          리뷰 가져오기를 진행했는데 카페24의 리뷰 데이터를 가져오지 못하는 경우, <strong>리뷰 게시판 ID</strong>가 올바르게 설정되어 있는지 확인이 필요합니다.
                        </p>
                        <div style={{
                          padding: '12px 15px',
                          background: '#f7fafc',
                          borderRadius: '6px'
                        }}>
                          <p style={{margin: '0 0 12px 0', fontSize: '13px', color: '#4a5568'}}>
                            <strong>리뷰 설정 페이지</strong>의 <strong>카페24 설정</strong>에서 <strong>리뷰 게시판 ID</strong>를 꼭 확인해 주세요.
                          </p>
                          <a
                            href="/reviewWriteConfig"
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '6px',
                              padding: '10px 16px',
                              background: '#2d3748',
                              color: 'white',
                              fontSize: '14px',
                              fontWeight: '600',
                              textDecoration: 'none',
                              borderRadius: '6px'
                            }}
                          >
                            <FeatherIcon icon="settings" size="14"/>
                            리뷰 설정으로 이동
                          </a>
                        </div>
                      </div>
                    </div>

                    {/* FAQ 3: 상품상세페이지 기본 리뷰 리스트 코드 */}
                    <div style={{
                      borderBottom: '1px solid #e2e8f0',
                      paddingBottom: '20px',
                      marginBottom: '20px'
                    }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '12px'
                      }}>
                        <span style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '24px',
                          height: '24px',
                          borderRadius: '4px',
                          background: '#2d3748',
                          color: 'white',
                          marginRight: '10px',
                          fontWeight: '700',
                          fontSize: '12px'
                        }}>Q</span>
                        <h4 style={{margin: 0, fontSize: '15px', fontWeight: '600', color: '#2d3748'}}>
                          상품상세페이지에 리뷰 리스트를 직접 코드로 넣으려면?
                        </h4>
                      </div>
                      <div style={{marginLeft: '34px', color: '#4a5568', lineHeight: '1.7', fontSize: '14px'}}>
                        <p style={{margin: '0 0 12px 0'}}>
                          상품 상세페이지에서 원하는 위치에 리뷰 리스트를 표시하려면, 아래 코드를 해당 위치에 삽입하세요.
                        </p>
                        <div style={{
                          background: '#2d3748',
                          borderRadius: '6px',
                          padding: '15px 20px',
                          marginBottom: '12px',
                          position: 'relative'
                        }}>
                          <code style={{
                            color: '#e2e8f0',
                            fontSize: '14px',
                            fontFamily: 'Monaco, Consolas, monospace'
                          }}>
                            &lt;div id="orp_prdReview"&gt;&lt;/div&gt;
                          </code>
                          <button
                            onClick={() => {
                              navigator.clipboard.writeText('<div id="orp_prdReview"></div>');
                              toast('코드가 클립보드에 복사되었습니다.');
                            }}
                            style={{
                              position: 'absolute',
                              top: '50%',
                              right: '12px',
                              transform: 'translateY(-50%)',
                              padding: '5px 10px',
                              borderRadius: '4px',
                              border: '1px solid #4a5568',
                              background: 'transparent',
                              color: '#a0aec0',
                              fontSize: '12px',
                              fontWeight: '500',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px'
                            }}
                          >
                            <FeatherIcon icon="copy" size="12"/>
                            복사
                          </button>
                        </div>
                        <p style={{margin: '0 0 8px 0'}}>
                          <strong>설치 위치:</strong> 카페24 관리자 &gt; 디자인 &gt; 디자인 편집 &gt; 상품 상세 페이지
                        </p>
                        <a
                          href="https://onnomad.notion.site/175f1bde930080bab77ee5c0d5974093?p=175f1bde9300809e85d0d4be26489a3b&pm=c"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '5px',
                            color: '#2d3748',
                            fontSize: '14px',
                            fontWeight: '600',
                            textDecoration: 'underline'
                          }}
                        >
                          <FeatherIcon icon="external-link" size="14"/>
                          상세 사용법 보기
                        </a>
                      </div>
                    </div>

                    {/* FAQ 4: 메뉴얼 보기 */}
                    <div>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '12px'
                      }}>
                        <span style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '24px',
                          height: '24px',
                          borderRadius: '4px',
                          background: '#2d3748',
                          color: 'white',
                          marginRight: '10px',
                          fontWeight: '700',
                          fontSize: '12px'
                        }}>Q</span>
                        <h4 style={{margin: 0, fontSize: '15px', fontWeight: '600', color: '#2d3748'}}>
                          더 자세한 사용 방법을 알고 싶어요
                        </h4>
                      </div>
                      <div style={{marginLeft: '34px', color: '#4a5568', lineHeight: '1.7', fontSize: '14px'}}>
                        <p style={{margin: '0 0 12px 0'}}>
                          온리플의 다양한 기능과 상세 설정 방법은 공식 매뉴얼에서 확인하실 수 있습니다.
                        </p>
                        <div style={{display: 'flex', gap: '10px', flexWrap: 'wrap'}}>
                          <a
                            href="https://onnomad.co.kr/manual"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '6px',
                              padding: '10px 16px',
                              background: '#2d3748',
                              color: 'white',
                              fontSize: '14px',
                              fontWeight: '600',
                              textDecoration: 'none',
                              borderRadius: '6px'
                            }}
                          >
                            <FeatherIcon icon="book-open" size="14"/>
                            전체 매뉴얼 보기
                          </a>
                          <a
                            href={`https://onnomad.co.kr/embed/chat?service=온리플&id=${encodeURIComponent(this.store.platformId || '')}&shopName=${encodeURIComponent(this.store.name || '')}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '6px',
                              padding: '10px 16px',
                              background: '#f7fafc',
                              border: '1px solid #e2e8f0',
                              color: '#2d3748',
                              fontSize: '14px',
                              fontWeight: '600',
                              textDecoration: 'none',
                              borderRadius: '6px'
                            }}
                          >
                            <FeatherIcon icon="message-circle" size="14"/>
                            상담쳇
                          </a>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <ModalLoading isLoading={this.isLoading}/>
            </div>
            :
            null
          }
        </div>

        {/* === 사전 설정 iframe 모달 (90% 화면) === */}
        {this.configIframe.open && (
          <div
            onClick={() => this.closeConfigIframe()}
            style={{
              position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
              background: 'rgba(15, 23, 42, 0.55)',
              zIndex: 10000,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              padding: '2vh 2vw'
            }}>
            <div onClick={(e) => e.stopPropagation()}
              style={{
                width: '90vw', height: '90vh', maxWidth: '90vw', maxHeight: '90vh',
                background: '#fff', borderRadius: 12, overflow: 'hidden',
                boxShadow: '0 20px 60px rgba(0,0,0,0.35)',
                display: 'flex', flexDirection: 'column'
              }}>
              <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '12px 18px', borderBottom: '1px solid #E2E8F0',
                background: '#F8FAFC', flexShrink: 0
              }}>
                <div style={{display: 'flex', alignItems: 'center', gap: 10, minWidth: 0}}>
                  <div style={{
                    width: 28, height: 28, borderRadius: 8,
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                  }}>
                    <FeatherIcon icon="settings" size="15" style={{color: 'white'}} />
                  </div>
                  <div style={{minWidth: 0}}>
                    <div style={{fontSize: 15, fontWeight: 700, color: '#1F2937', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                      {this.configIframe.title || '설정'}
                    </div>
                    <div style={{fontSize: 11, color: '#94A3B8', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                      {this.configIframe.path}
                    </div>
                  </div>
                </div>
                <div style={{display: 'flex', gap: 6, flexShrink: 0}}>
                  <a href={this.configIframe.path} target="_blank" rel="noopener noreferrer"
                    title="새 탭에서 열기"
                    style={{
                      width: 32, height: 32, borderRadius: 6,
                      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                      background: '#fff', border: '1px solid #E2E8F0', color: '#475569',
                      textDecoration: 'none'
                    }}>
                    <FeatherIcon icon="external-link" size="15" />
                  </a>
                  <button type="button" onClick={() => this.closeConfigIframe()}
                    title="닫기"
                    style={{
                      width: 32, height: 32, borderRadius: 6, padding: 0,
                      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                      background: '#fff', border: '1px solid #E2E8F0', color: '#475569',
                      cursor: 'pointer'
                    }}>
                    <FeatherIcon icon="x" size="16" />
                  </button>
                </div>
              </div>
              <iframe
                src={this.configIframe.path + (this.configIframe.path.indexOf('?') === -1 ? '?embed=1' : '&embed=1')}
                title={this.configIframe.title}
                style={{
                  border: 'none', width: '100%', flex: 1, background: '#fff'
                }} />
            </div>
          </div>
        )}

      </>
    )
  }
}

export default EasySetting;
